/**
 * Generated from CharlesDickensCutouts.fla
 */
export function CharlesDickensCutouts(this: ICharlesDickensCutouts) {
	const cutouts = this.cutouts;
	if (!cutouts[0] && cutouts.elementFactory) {
		cutouts[0] = cutouts.elementFactory(0,undefined);
	}
	if (cutouts[0]) {
		CharlesDickensCutouts_dicAirplane_cutout.call(cutouts[0] as ICharlesDickensCutouts_dicAirplane_cutout);
		cutouts[0].x = 13.45;
		cutouts[0].y = 407.75;
		if (cutouts[0].onLayout) cutouts[0].onLayout();
	}
	if (!cutouts[1] && cutouts.elementFactory) {
		cutouts[1] = cutouts.elementFactory(1,undefined);
	}
	if (cutouts[1]) {
		CharlesDickensCutouts_dicBAgast_cutout.call(cutouts[1] as ICharlesDickensCutouts_dicBAgast_cutout);
		cutouts[1].x = 832;
		cutouts[1].y = 465;
		if (cutouts[1].onLayout) cutouts[1].onLayout();
	}
	if (!cutouts[2] && cutouts.elementFactory) {
		cutouts[2] = cutouts.elementFactory(2,undefined);
	}
	if (cutouts[2]) {
		CharlesDickensCutouts_dicBalloons_cutout.call(cutouts[2] as ICharlesDickensCutouts_dicBalloons_cutout);
		cutouts[2].x = 915.5;
		cutouts[2].y = 636.5;
		if (cutouts[2].onLayout) cutouts[2].onLayout();
	}
	if (!cutouts[3] && cutouts.elementFactory) {
		cutouts[3] = cutouts.elementFactory(3,undefined);
	}
	if (cutouts[3]) {
		CharlesDickensCutouts_dicBanana_cutout.call(cutouts[3] as ICharlesDickensCutouts_dicBanana_cutout);
		cutouts[3].x = 912;
		cutouts[3].y = 651.5;
		if (cutouts[3].onLayout) cutouts[3].onLayout();
	}
	if (!cutouts[4] && cutouts.elementFactory) {
		cutouts[4] = cutouts.elementFactory(4,undefined);
	}
	if (cutouts[4]) {
		CharlesDickensCutouts_dicBaseballField_cutout.call(cutouts[4] as ICharlesDickensCutouts_dicBaseballField_cutout);
		cutouts[4].x = 25.65;
		cutouts[4].y = 641.4;
		if (cutouts[4].onLayout) cutouts[4].onLayout();
	}
	if (!cutouts[5] && cutouts.elementFactory) {
		cutouts[5] = cutouts.elementFactory(5,undefined);
	}
	if (cutouts[5]) {
		CharlesDickensCutouts_dicBaseballLights_cutout.call(cutouts[5] as ICharlesDickensCutouts_dicBaseballLights_cutout);
		cutouts[5].x = 879;
		cutouts[5].y = 635;
		if (cutouts[5].onLayout) cutouts[5].onLayout();
	}
	if (!cutouts[6] && cutouts.elementFactory) {
		cutouts[6] = cutouts.elementFactory(6,undefined);
	}
	if (cutouts[6]) {
		CharlesDickensCutouts_dicBBaseball_cutout.call(cutouts[6] as ICharlesDickensCutouts_dicBBaseball_cutout);
		cutouts[6].x = 801;
		cutouts[6].y = 437;
		if (cutouts[6].onLayout) cutouts[6].onLayout();
	}
	if (!cutouts[7] && cutouts.elementFactory) {
		cutouts[7] = cutouts.elementFactory(7,undefined);
	}
	if (cutouts[7]) {
		CharlesDickensCutouts_dicBButterfly_cutout.call(cutouts[7] as ICharlesDickensCutouts_dicBButterfly_cutout);
		cutouts[7].x = 835;
		cutouts[7].y = 406;
		if (cutouts[7].onLayout) cutouts[7].onLayout();
	}
	if (!cutouts[8] && cutouts.elementFactory) {
		cutouts[8] = cutouts.elementFactory(8,undefined);
	}
	if (cutouts[8]) {
		CharlesDickensCutouts_dicBCircus_cutout.call(cutouts[8] as ICharlesDickensCutouts_dicBCircus_cutout);
		cutouts[8].x = 812;
		cutouts[8].y = 470.5;
		if (cutouts[8].onLayout) cutouts[8].onLayout();
	}
	if (!cutouts[9] && cutouts.elementFactory) {
		cutouts[9] = cutouts.elementFactory(9,undefined);
	}
	if (cutouts[9]) {
		CharlesDickensCutouts_dicBConcerned_cutout.call(cutouts[9] as ICharlesDickensCutouts_dicBConcerned_cutout);
		cutouts[9].x = 834;
		cutouts[9].y = 465;
		if (cutouts[9].onLayout) cutouts[9].onLayout();
	}
	if (!cutouts[10] && cutouts.elementFactory) {
		cutouts[10] = cutouts.elementFactory(10,undefined);
	}
	if (cutouts[10]) {
		CharlesDickensCutouts_dicBeanbag_cutout.call(cutouts[10] as ICharlesDickensCutouts_dicBeanbag_cutout);
		cutouts[10].x = 582;
		cutouts[10].y = 442;
		if (cutouts[10].onLayout) cutouts[10].onLayout();
	}
	if (!cutouts[11] && cutouts.elementFactory) {
		cutouts[11] = cutouts.elementFactory(11,undefined);
	}
	if (cutouts[11]) {
		CharlesDickensCutouts_dicBed_cutout.call(cutouts[11] as ICharlesDickensCutouts_dicBed_cutout);
		cutouts[11].x = 367;
		cutouts[11].y = 488;
		if (cutouts[11].onLayout) cutouts[11].onLayout();
	}
	if (!cutouts[12] && cutouts.elementFactory) {
		cutouts[12] = cutouts.elementFactory(12,undefined);
	}
	if (cutouts[12]) {
		CharlesDickensCutouts_dicBExcited_cutout.call(cutouts[12] as ICharlesDickensCutouts_dicBExcited_cutout);
		cutouts[12].x = 836;
		cutouts[12].y = 465.5;
		if (cutouts[12].onLayout) cutouts[12].onLayout();
	}
	if (!cutouts[13] && cutouts.elementFactory) {
		cutouts[13] = cutouts.elementFactory(13,undefined);
	}
	if (cutouts[13]) {
		CharlesDickensCutouts_dicBFlying_cutout.call(cutouts[13] as ICharlesDickensCutouts_dicBFlying_cutout);
		cutouts[13].x = 456;
		cutouts[13].y = 481;
		if (cutouts[13].onLayout) cutouts[13].onLayout();
	}
	if (!cutouts[14] && cutouts.elementFactory) {
		cutouts[14] = cutouts.elementFactory(14,undefined);
	}
	if (cutouts[14]) {
		CharlesDickensCutouts_dicBHome_cutout.call(cutouts[14] as ICharlesDickensCutouts_dicBHome_cutout);
		cutouts[14].x = 764;
		cutouts[14].y = 566;
		if (cutouts[14].onLayout) cutouts[14].onLayout();
	}
	if (!cutouts[15] && cutouts.elementFactory) {
		cutouts[15] = cutouts.elementFactory(15,undefined);
	}
	if (cutouts[15]) {
		CharlesDickensCutouts_dicBlanket_cutout.call(cutouts[15] as ICharlesDickensCutouts_dicBlanket_cutout);
		cutouts[15].x = 539;
		cutouts[15].y = 620;
		if (cutouts[15].onLayout) cutouts[15].onLayout();
	}
	if (!cutouts[16] && cutouts.elementFactory) {
		cutouts[16] = cutouts.elementFactory(16,undefined);
	}
	if (cutouts[16]) {
		CharlesDickensCutouts_dicBLaying_cutout.call(cutouts[16] as ICharlesDickensCutouts_dicBLaying_cutout);
		cutouts[16].x = 717;
		cutouts[16].y = 543;
		if (cutouts[16].onLayout) cutouts[16].onLayout();
	}
	if (!cutouts[17] && cutouts.elementFactory) {
		cutouts[17] = cutouts.elementFactory(17,undefined);
	}
	if (cutouts[17]) {
		CharlesDickensCutouts_dicBMuseum_cutout.call(cutouts[17] as ICharlesDickensCutouts_dicBMuseum_cutout);
		cutouts[17].x = 843;
		cutouts[17].y = 489;
		if (cutouts[17].onLayout) cutouts[17].onLayout();
	}
	if (!cutouts[18] && cutouts.elementFactory) {
		cutouts[18] = cutouts.elementFactory(18,undefined);
	}
	if (cutouts[18]) {
		CharlesDickensCutouts_dicBowlingball_cutout.call(cutouts[18] as ICharlesDickensCutouts_dicBowlingball_cutout);
		cutouts[18].x = 889;
		cutouts[18].y = 630.5;
		if (cutouts[18].onLayout) cutouts[18].onLayout();
	}
	if (!cutouts[19] && cutouts.elementFactory) {
		cutouts[19] = cutouts.elementFactory(19,undefined);
	}
	if (cutouts[19]) {
		CharlesDickensCutouts_dicBPointing_cutout.call(cutouts[19] as ICharlesDickensCutouts_dicBPointing_cutout);
		cutouts[19].x = 832.5;
		cutouts[19].y = 469;
		if (cutouts[19].onLayout) cutouts[19].onLayout();
	}
	if (!cutouts[20] && cutouts.elementFactory) {
		cutouts[20] = cutouts.elementFactory(20,undefined);
	}
	if (cutouts[20]) {
		CharlesDickensCutouts_dicBScared_cutout.call(cutouts[20] as ICharlesDickensCutouts_dicBScared_cutout);
		cutouts[20].x = 826.5;
		cutouts[20].y = 428;
		if (cutouts[20].onLayout) cutouts[20].onLayout();
	}
	if (!cutouts[21] && cutouts.elementFactory) {
		cutouts[21] = cutouts.elementFactory(21,undefined);
	}
	if (cutouts[21]) {
		CharlesDickensCutouts_dicBSea_cutout.call(cutouts[21] as ICharlesDickensCutouts_dicBSea_cutout);
		cutouts[21].x = 817.5;
		cutouts[21].y = 423.5;
		if (cutouts[21].onLayout) cutouts[21].onLayout();
	}
	if (!cutouts[22] && cutouts.elementFactory) {
		cutouts[22] = cutouts.elementFactory(22,undefined);
	}
	if (cutouts[22]) {
		CharlesDickensCutouts_dicBSittingconfused_cutout.call(cutouts[22] as ICharlesDickensCutouts_dicBSittingconfused_cutout);
		cutouts[22].x = 834.5;
		cutouts[22].y = 476;
		if (cutouts[22].onLayout) cutouts[22].onLayout();
	}
	if (!cutouts[23] && cutouts.elementFactory) {
		cutouts[23] = cutouts.elementFactory(23,undefined);
	}
	if (cutouts[23]) {
		CharlesDickensCutouts_dicBSpace_cutout.call(cutouts[23] as ICharlesDickensCutouts_dicBSpace_cutout);
		cutouts[23].x = 701.5;
		cutouts[23].y = 492;
		if (cutouts[23].onLayout) cutouts[23].onLayout();
	}
	if (!cutouts[24] && cutouts.elementFactory) {
		cutouts[24] = cutouts.elementFactory(24,undefined);
	}
	if (cutouts[24]) {
		CharlesDickensCutouts_dicButterflyB_cutout.call(cutouts[24] as ICharlesDickensCutouts_dicButterflyB_cutout);
		cutouts[24].x = 961.5;
		cutouts[24].y = 713.5;
		if (cutouts[24].onLayout) cutouts[24].onLayout();
	}
	if (!cutouts[25] && cutouts.elementFactory) {
		cutouts[25] = cutouts.elementFactory(25,undefined);
	}
	if (cutouts[25]) {
		CharlesDickensCutouts_dicButterflyBack_cutout.call(cutouts[25] as ICharlesDickensCutouts_dicButterflyBack_cutout);
		cutouts[25].x = 431.5;
		cutouts[25].y = 403;
		if (cutouts[25].onLayout) cutouts[25].onLayout();
	}
	if (!cutouts[26] && cutouts.elementFactory) {
		cutouts[26] = cutouts.elementFactory(26,undefined);
	}
	if (cutouts[26]) {
		CharlesDickensCutouts_dicButterflyFront_cutout.call(cutouts[26] as ICharlesDickensCutouts_dicButterflyFront_cutout);
		cutouts[26].x = 956.5;
		cutouts[26].y = 715.5;
		if (cutouts[26].onLayout) cutouts[26].onLayout();
	}
	if (!cutouts[27] && cutouts.elementFactory) {
		cutouts[27] = cutouts.elementFactory(27,undefined);
	}
	if (cutouts[27]) {
		CharlesDickensCutouts_dicButterflyR_cutout.call(cutouts[27] as ICharlesDickensCutouts_dicButterflyR_cutout);
		cutouts[27].x = 933.5;
		cutouts[27].y = 691;
		if (cutouts[27].onLayout) cutouts[27].onLayout();
	}
	if (!cutouts[28] && cutouts.elementFactory) {
		cutouts[28] = cutouts.elementFactory(28,undefined);
	}
	if (cutouts[28]) {
		CharlesDickensCutouts_dicButterflyY_cutout.call(cutouts[28] as ICharlesDickensCutouts_dicButterflyY_cutout);
		cutouts[28].x = 939;
		cutouts[28].y = 715;
		if (cutouts[28].onLayout) cutouts[28].onLayout();
	}
	if (!cutouts[29] && cutouts.elementFactory) {
		cutouts[29] = cutouts.elementFactory(29,undefined);
	}
	if (cutouts[29]) {
		CharlesDickensCutouts_dicCastle_cutout.call(cutouts[29] as ICharlesDickensCutouts_dicCastle_cutout);
		cutouts[29].x = 528;
		cutouts[29].y = 202;
		if (cutouts[29].onLayout) cutouts[29].onLayout();
	}
	if (!cutouts[30] && cutouts.elementFactory) {
		cutouts[30] = cutouts.elementFactory(30,undefined);
	}
	if (cutouts[30]) {
		CharlesDickensCutouts_dicChickens1_cutout.call(cutouts[30] as ICharlesDickensCutouts_dicChickens1_cutout);
		cutouts[30].x = 916.5;
		cutouts[30].y = 649.5;
		if (cutouts[30].onLayout) cutouts[30].onLayout();
	}
	if (!cutouts[31] && cutouts.elementFactory) {
		cutouts[31] = cutouts.elementFactory(31,undefined);
	}
	if (cutouts[31]) {
		CharlesDickensCutouts_dicChickens2_cutout.call(cutouts[31] as ICharlesDickensCutouts_dicChickens2_cutout);
		cutouts[31].x = 901;
		cutouts[31].y = 639;
		if (cutouts[31].onLayout) cutouts[31].onLayout();
	}
	if (!cutouts[32] && cutouts.elementFactory) {
		cutouts[32] = cutouts.elementFactory(32,undefined);
	}
	if (cutouts[32]) {
		CharlesDickensCutouts_dicChickens3_cutout.call(cutouts[32] as ICharlesDickensCutouts_dicChickens3_cutout);
		cutouts[32].x = 974;
		cutouts[32].y = 716;
		if (cutouts[32].onLayout) cutouts[32].onLayout();
	}
	if (!cutouts[33] && cutouts.elementFactory) {
		cutouts[33] = cutouts.elementFactory(33,undefined);
	}
	if (cutouts[33]) {
		CharlesDickensCutouts_dicChickens4_cutout.call(cutouts[33] as ICharlesDickensCutouts_dicChickens4_cutout);
		cutouts[33].x = 905.5;
		cutouts[33].y = 642.5;
		if (cutouts[33].onLayout) cutouts[33].onLayout();
	}
	if (!cutouts[34] && cutouts.elementFactory) {
		cutouts[34] = cutouts.elementFactory(34,undefined);
	}
	if (cutouts[34]) {
		CharlesDickensCutouts_dicChickens5_cutout.call(cutouts[34] as ICharlesDickensCutouts_dicChickens5_cutout);
		cutouts[34].x = 905.5;
		cutouts[34].y = 655;
		if (cutouts[34].onLayout) cutouts[34].onLayout();
	}
	if (!cutouts[35] && cutouts.elementFactory) {
		cutouts[35] = cutouts.elementFactory(35,undefined);
	}
	if (cutouts[35]) {
		CharlesDickensCutouts_dicChickens6_cutout.call(cutouts[35] as ICharlesDickensCutouts_dicChickens6_cutout);
		cutouts[35].x = 887.5;
		cutouts[35].y = 638.5;
		if (cutouts[35].onLayout) cutouts[35].onLayout();
	}
	if (!cutouts[36] && cutouts.elementFactory) {
		cutouts[36] = cutouts.elementFactory(36,undefined);
	}
	if (cutouts[36]) {
		CharlesDickensCutouts_dicChickens7_cutout.call(cutouts[36] as ICharlesDickensCutouts_dicChickens7_cutout);
		cutouts[36].x = 936.5;
		cutouts[36].y = 634.5;
		if (cutouts[36].onLayout) cutouts[36].onLayout();
	}
	if (!cutouts[37] && cutouts.elementFactory) {
		cutouts[37] = cutouts.elementFactory(37,undefined);
	}
	if (cutouts[37]) {
		CharlesDickensCutouts_dicChickens8_cutout.call(cutouts[37] as ICharlesDickensCutouts_dicChickens8_cutout);
		cutouts[37].x = 898.5;
		cutouts[37].y = 636.5;
		if (cutouts[37].onLayout) cutouts[37].onLayout();
	}
	if (!cutouts[38] && cutouts.elementFactory) {
		cutouts[38] = cutouts.elementFactory(38,undefined);
	}
	if (cutouts[38]) {
		CharlesDickensCutouts_dicChickens9_cutout.call(cutouts[38] as ICharlesDickensCutouts_dicChickens9_cutout);
		cutouts[38].x = 933.5;
		cutouts[38].y = 636.5;
		if (cutouts[38].onLayout) cutouts[38].onLayout();
	}
	if (!cutouts[39] && cutouts.elementFactory) {
		cutouts[39] = cutouts.elementFactory(39,undefined);
	}
	if (cutouts[39]) {
		CharlesDickensCutouts_dicCircus_cutout.call(cutouts[39] as ICharlesDickensCutouts_dicCircus_cutout);
		cutouts[39].x = 351.5;
		cutouts[39].y = 285;
		if (cutouts[39].onLayout) cutouts[39].onLayout();
	}
	if (!cutouts[40] && cutouts.elementFactory) {
		cutouts[40] = cutouts.elementFactory(40,undefined);
	}
	if (cutouts[40]) {
		CharlesDickensCutouts_dicCloud1_cutout.call(cutouts[40] as ICharlesDickensCutouts_dicCloud1_cutout);
		cutouts[40].x = 490.5;
		cutouts[40].y = 676.5;
		if (cutouts[40].onLayout) cutouts[40].onLayout();
	}
	if (!cutouts[41] && cutouts.elementFactory) {
		cutouts[41] = cutouts.elementFactory(41,undefined);
	}
	if (cutouts[41]) {
		CharlesDickensCutouts_dicCloud2_cutout.call(cutouts[41] as ICharlesDickensCutouts_dicCloud2_cutout);
		cutouts[41].x = 429;
		cutouts[41].y = 517.5;
		if (cutouts[41].onLayout) cutouts[41].onLayout();
	}
	if (!cutouts[42] && cutouts.elementFactory) {
		cutouts[42] = cutouts.elementFactory(42,undefined);
	}
	if (cutouts[42]) {
		CharlesDickensCutouts_dicCloud3_cutout.call(cutouts[42] as ICharlesDickensCutouts_dicCloud3_cutout);
		cutouts[42].x = 565;
		cutouts[42].y = 585.5;
		if (cutouts[42].onLayout) cutouts[42].onLayout();
	}
	if (!cutouts[43] && cutouts.elementFactory) {
		cutouts[43] = cutouts.elementFactory(43,undefined);
	}
	if (cutouts[43]) {
		CharlesDickensCutouts_dicCloudsFront_cutout.call(cutouts[43] as ICharlesDickensCutouts_dicCloudsFront_cutout);
		cutouts[43].x = -454.5;
		cutouts[43].y = 256;
		if (cutouts[43].onLayout) cutouts[43].onLayout();
	}
	if (!cutouts[44] && cutouts.elementFactory) {
		cutouts[44] = cutouts.elementFactory(44,undefined);
	}
	if (cutouts[44]) {
		CharlesDickensCutouts_dicCouch_cutout.call(cutouts[44] as ICharlesDickensCutouts_dicCouch_cutout);
		cutouts[44].x = 481;
		cutouts[44].y = 492;
		if (cutouts[44].onLayout) cutouts[44].onLayout();
	}
	if (!cutouts[45] && cutouts.elementFactory) {
		cutouts[45] = cutouts.elementFactory(45,undefined);
	}
	if (cutouts[45]) {
		CharlesDickensCutouts_dicLollipop_cutout.call(cutouts[45] as ICharlesDickensCutouts_dicLollipop_cutout);
		cutouts[45].x = 880;
		cutouts[45].y = 605;
		if (cutouts[45].onLayout) cutouts[45].onLayout();
	}
	if (!cutouts[46] && cutouts.elementFactory) {
		cutouts[46] = cutouts.elementFactory(46,undefined);
	}
	if (cutouts[46]) {
		CharlesDickensCutouts_dicMuseum_cutout.call(cutouts[46] as ICharlesDickensCutouts_dicMuseum_cutout);
		cutouts[46].x = 356.5;
		cutouts[46].y = 465.5;
		if (cutouts[46].onLayout) cutouts[46].onLayout();
	}
	if (!cutouts[47] && cutouts.elementFactory) {
		cutouts[47] = cutouts.elementFactory(47,undefined);
	}
	if (cutouts[47]) {
		CharlesDickensCutouts_dicPopcorn_cutout.call(cutouts[47] as ICharlesDickensCutouts_dicPopcorn_cutout);
		cutouts[47].x = 430;
		cutouts[47].y = 429;
		if (cutouts[47].onLayout) cutouts[47].onLayout();
	}
	if (!cutouts[48] && cutouts.elementFactory) {
		cutouts[48] = cutouts.elementFactory(48,undefined);
	}
	if (cutouts[48]) {
		CharlesDickensCutouts_dicPopcorn1_cutout.call(cutouts[48] as ICharlesDickensCutouts_dicPopcorn1_cutout);
		cutouts[48].x = 970.5;
		cutouts[48].y = 722.5;
		if (cutouts[48].onLayout) cutouts[48].onLayout();
	}
	if (!cutouts[49] && cutouts.elementFactory) {
		cutouts[49] = cutouts.elementFactory(49,undefined);
	}
	if (cutouts[49]) {
		CharlesDickensCutouts_dicPopcorn2_cutout.call(cutouts[49] as ICharlesDickensCutouts_dicPopcorn2_cutout);
		cutouts[49].x = 980;
		cutouts[49].y = 731.5;
		if (cutouts[49].onLayout) cutouts[49].onLayout();
	}
	if (!cutouts[50] && cutouts.elementFactory) {
		cutouts[50] = cutouts.elementFactory(50,undefined);
	}
	if (cutouts[50]) {
		CharlesDickensCutouts_dicPopcorn3_cutout.call(cutouts[50] as ICharlesDickensCutouts_dicPopcorn3_cutout);
		cutouts[50].x = 989.5;
		cutouts[50].y = 742;
		if (cutouts[50].onLayout) cutouts[50].onLayout();
	}
	if (!cutouts[51] && cutouts.elementFactory) {
		cutouts[51] = cutouts.elementFactory(51,undefined);
	}
	if (cutouts[51]) {
		CharlesDickensCutouts_dicPopcorn4_cutout.call(cutouts[51] as ICharlesDickensCutouts_dicPopcorn4_cutout);
		cutouts[51].x = 978.5;
		cutouts[51].y = 734;
		if (cutouts[51].onLayout) cutouts[51].onLayout();
	}
	if (!cutouts[52] && cutouts.elementFactory) {
		cutouts[52] = cutouts.elementFactory(52,undefined);
	}
	if (cutouts[52]) {
		CharlesDickensCutouts_dicSeaBubbles1_cutout.call(cutouts[52] as ICharlesDickensCutouts_dicSeaBubbles1_cutout);
		cutouts[52].x = 848;
		cutouts[52].y = 541;
		if (cutouts[52].onLayout) cutouts[52].onLayout();
	}
	if (!cutouts[53] && cutouts.elementFactory) {
		cutouts[53] = cutouts.elementFactory(53,undefined);
	}
	if (cutouts[53]) {
		CharlesDickensCutouts_dicSeaBubbles2_cutout.call(cutouts[53] as ICharlesDickensCutouts_dicSeaBubbles2_cutout);
		cutouts[53].x = 774.5;
		cutouts[53].y = 554.5;
		if (cutouts[53].onLayout) cutouts[53].onLayout();
	}
	if (!cutouts[54] && cutouts.elementFactory) {
		cutouts[54] = cutouts.elementFactory(54,undefined);
	}
	if (cutouts[54]) {
		CharlesDickensCutouts_dicSeaBubbles3_cutout.call(cutouts[54] as ICharlesDickensCutouts_dicSeaBubbles3_cutout);
		cutouts[54].x = 872;
		cutouts[54].y = 554.5;
		if (cutouts[54].onLayout) cutouts[54].onLayout();
	}
	if (!cutouts[55] && cutouts.elementFactory) {
		cutouts[55] = cutouts.elementFactory(55,undefined);
	}
	if (cutouts[55]) {
		CharlesDickensCutouts_dicSeaFish1_cutout.call(cutouts[55] as ICharlesDickensCutouts_dicSeaFish1_cutout);
		cutouts[55].x = 915.5;
		cutouts[55].y = 729;
		if (cutouts[55].onLayout) cutouts[55].onLayout();
	}
	if (!cutouts[56] && cutouts.elementFactory) {
		cutouts[56] = cutouts.elementFactory(56,undefined);
	}
	if (cutouts[56]) {
		CharlesDickensCutouts_dicSeaFish2_cutout.call(cutouts[56] as ICharlesDickensCutouts_dicSeaFish2_cutout);
		cutouts[56].x = 930.5;
		cutouts[56].y = 734;
		if (cutouts[56].onLayout) cutouts[56].onLayout();
	}
	if (!cutouts[57] && cutouts.elementFactory) {
		cutouts[57] = cutouts.elementFactory(57,undefined);
	}
	if (cutouts[57]) {
		CharlesDickensCutouts_dicSeaPlant1_cutout.call(cutouts[57] as ICharlesDickensCutouts_dicSeaPlant1_cutout);
		cutouts[57].x = 877.5;
		cutouts[57].y = 597.5;
		if (cutouts[57].onLayout) cutouts[57].onLayout();
	}
	if (!cutouts[58] && cutouts.elementFactory) {
		cutouts[58] = cutouts.elementFactory(58,undefined);
	}
	if (cutouts[58]) {
		CharlesDickensCutouts_dicSeaPlant2_cutout.call(cutouts[58] as ICharlesDickensCutouts_dicSeaPlant2_cutout);
		cutouts[58].x = 884.5;
		cutouts[58].y = 607;
		if (cutouts[58].onLayout) cutouts[58].onLayout();
	}
	if (!cutouts[59] && cutouts.elementFactory) {
		cutouts[59] = cutouts.elementFactory(59,undefined);
	}
	if (cutouts[59]) {
		CharlesDickensCutouts_dicSeaPlant3_cutout.call(cutouts[59] as ICharlesDickensCutouts_dicSeaPlant3_cutout);
		cutouts[59].x = 837;
		cutouts[59].y = 497.5;
		if (cutouts[59].onLayout) cutouts[59].onLayout();
	}
	if (!cutouts[60] && cutouts.elementFactory) {
		cutouts[60] = cutouts.elementFactory(60,undefined);
	}
	if (cutouts[60]) {
		CharlesDickensCutouts_dicSmallballoon_cutout.call(cutouts[60] as ICharlesDickensCutouts_dicSmallballoon_cutout);
		cutouts[60].x = 955;
		cutouts[60].y = 703;
		if (cutouts[60].onLayout) cutouts[60].onLayout();
	}
	if (!cutouts[61] && cutouts.elementFactory) {
		cutouts[61] = cutouts.elementFactory(61,undefined);
	}
	if (cutouts[61]) {
		CharlesDickensCutouts_dicSmallchicken_cutout.call(cutouts[61] as ICharlesDickensCutouts_dicSmallchicken_cutout);
		cutouts[61].x = 953.5;
		cutouts[61].y = 694.5;
		if (cutouts[61].onLayout) cutouts[61].onLayout();
	}
	if (!cutouts[62] && cutouts.elementFactory) {
		cutouts[62] = cutouts.elementFactory(62,undefined);
	}
	if (cutouts[62]) {
		CharlesDickensCutouts_dicSmallpopcorn_cutout.call(cutouts[62] as ICharlesDickensCutouts_dicSmallpopcorn_cutout);
		cutouts[62].x = 930.5;
		cutouts[62].y = 730;
		if (cutouts[62].onLayout) cutouts[62].onLayout();
	}
	if (!cutouts[63] && cutouts.elementFactory) {
		cutouts[63] = cutouts.elementFactory(63,undefined);
	}
	if (cutouts[63]) {
		CharlesDickensCutouts_dicSmallworms_cutout.call(cutouts[63] as ICharlesDickensCutouts_dicSmallworms_cutout);
		cutouts[63].x = 920;
		cutouts[63].y = 733.5;
		if (cutouts[63].onLayout) cutouts[63].onLayout();
	}
	if (!cutouts[64] && cutouts.elementFactory) {
		cutouts[64] = cutouts.elementFactory(64,undefined);
	}
	if (cutouts[64]) {
		CharlesDickensCutouts_dicSpacePlanet2_cutout.call(cutouts[64] as ICharlesDickensCutouts_dicSpacePlanet2_cutout);
		cutouts[64].x = 889.5;
		cutouts[64].y = 634;
		if (cutouts[64].onLayout) cutouts[64].onLayout();
	}
	if (!cutouts[65] && cutouts.elementFactory) {
		cutouts[65] = cutouts.elementFactory(65,undefined);
	}
	if (cutouts[65]) {
		CharlesDickensCutouts_dicSpacePlanet3_cutout.call(cutouts[65] as ICharlesDickensCutouts_dicSpacePlanet3_cutout);
		cutouts[65].x = 375;
		cutouts[65].y = 485;
		if (cutouts[65].onLayout) cutouts[65].onLayout();
	}
	if (!cutouts[66] && cutouts.elementFactory) {
		cutouts[66] = cutouts.elementFactory(66,undefined);
	}
	if (cutouts[66]) {
		CharlesDickensCutouts_dicSpacePlanet4_cutout.call(cutouts[66] as ICharlesDickensCutouts_dicSpacePlanet4_cutout);
		cutouts[66].x = 956;
		cutouts[66].y = 700.5;
		if (cutouts[66].onLayout) cutouts[66].onLayout();
	}
	if (!cutouts[67] && cutouts.elementFactory) {
		cutouts[67] = cutouts.elementFactory(67,undefined);
	}
	if (cutouts[67]) {
		CharlesDickensCutouts_dicSpaceSatellite_cutout.call(cutouts[67] as ICharlesDickensCutouts_dicSpaceSatellite_cutout);
		cutouts[67].x = 779.5;
		cutouts[67].y = 602.5;
		if (cutouts[67].onLayout) cutouts[67].onLayout();
	}
	if (!cutouts[68] && cutouts.elementFactory) {
		cutouts[68] = cutouts.elementFactory(68,undefined);
	}
	if (cutouts[68]) {
		CharlesDickensCutouts_dicSpaceship_cutout.call(cutouts[68] as ICharlesDickensCutouts_dicSpaceship_cutout);
		cutouts[68].x = 184;
		cutouts[68].y = 401.5;
		if (cutouts[68].onLayout) cutouts[68].onLayout();
	}
	if (!cutouts[69] && cutouts.elementFactory) {
		cutouts[69] = cutouts.elementFactory(69,undefined);
	}
	if (cutouts[69]) {
		CharlesDickensCutouts_dicTennisracket_cutout.call(cutouts[69] as ICharlesDickensCutouts_dicTennisracket_cutout);
		cutouts[69].x = 841.5;
		cutouts[69].y = 582;
		if (cutouts[69].onLayout) cutouts[69].onLayout();
	}
	if (!cutouts[70] && cutouts.elementFactory) {
		cutouts[70] = cutouts.elementFactory(70,undefined);
	}
	if (cutouts[70]) {
		CharlesDickensCutouts_dicWhale_cutout.call(cutouts[70] as ICharlesDickensCutouts_dicWhale_cutout);
		cutouts[70].x = 101.5;
		cutouts[70].y = 447;
		if (cutouts[70].onLayout) cutouts[70].onLayout();
	}
	if (!cutouts[71] && cutouts.elementFactory) {
		cutouts[71] = cutouts.elementFactory(71,undefined);
	}
	if (cutouts[71]) {
		CharlesDickensCutouts_dicWorms_cutout.call(cutouts[71] as ICharlesDickensCutouts_dicWorms_cutout);
		cutouts[71].x = 521;
		cutouts[71].y = 662;
		if (cutouts[71].onLayout) cutouts[71].onLayout();
	}
	return this;
}
function CharlesDickensCutouts_dicAirplane_cutout(this: ICharlesDickensCutouts_dicAirplane_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [286.35,9.40,557.70,9.40,720.50,15.00,733.60,-9.30,761.65,-9.30,776.65,15.00,993.70,26.25,1064.85,15.00,1124.70,16.90,1182.75,22.50,1394.15,18.75,1667.35,13.15,1981.75,11.25,2024.80,13.15,2037.90,39.35,2030.40,71.15,1998.60,95.45,1921.85,117.95,1644.90,138.50,1366.05,160.95,1405.35,222.75,1423.45,310.70,1418.45,400.50,1377.30,475.35,1411.00,494.05,1431.60,533.35,1439.10,578.25,1437.90,630.75,1424.10,654.95,1407.30,692.40,1371.70,707.35,1334.25,707.40,1304.35,692.40,1287.50,658.70,1261.85,632.60,1242.60,596.95,1162.20,609.60,1057.60,602.75,973.60,562.65,930.90,527.35,877.45,555.75,888.30,606.10,883.25,639.95,868.30,664.30,851.45,668.05,838.35,711.10,804.65,729.80,764.75,722.10,739.15,692.35,731.65,666.15,707.35,638.10,701.10,570.15,730.70,519.80,759.75,503.35,809.30,489.05,823.45,451.20,775.35,403.10,741.65,353.45,722.80,310.35,645.10,312.30,575.10,305.20,559.85,293.80,562.25,259.50,627.65,242.45,709.20,239.55,709.20,151.60,479.10,147.85,194.65,140.35,28.10,127.25,-11.20,110.45,-16.80,78.60,0.00,35.55,31.85,18.75];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicAirplane.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 2024.00;
	sprite.height = 717.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol1(this: ICharlesDickensCutouts_Symbol1) {
	return this;
}
function CharlesDickensCutouts_dicAirplane(this: ICharlesDickensCutouts_dicAirplane) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-airplane.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBAgast_cutout(this: ICharlesDickensCutouts_dicBAgast_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [82.30,5.90,132.25,-12.70,202.80,-13.70,270.40,4.95,320.35,42.15,346.80,99.00,352.65,168.55,367.30,181.25,372.20,216.50,361.45,248.85,351.65,265.50,384.95,269.40,390.80,290.00,395.70,318.40,381.05,342.90,374.60,359.05,335.95,359.55,303.65,376.95,263.10,387.55,270.35,442.75,273.25,483.90,264.45,502.50,271.30,527.95,298.75,538.75,314.40,558.35,311.45,582.80,295.80,602.40,261.50,608.30,218.40,604.35,192.95,617.10,143.95,619.05,99.00,606.35,79.40,591.65,76.45,547.60,82.35,529.95,71.55,504.50,69.60,472.15,82.35,452.55,93.10,333.05,55.90,306.60,20.60,303.65,0.05,282.10,-12.70,253.70,-9.75,216.45,-0.95,200.80,-4.85,152.85,2.00,96.00,16.20,68.95,30.35,41.20];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBAgast.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 384.00;
	sprite.height = 606.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol2(this: ICharlesDickensCutouts_Symbol2) {
	return this;
}
function CharlesDickensCutouts_dicBAgast(this: ICharlesDickensCutouts_dicBAgast) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-agast.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBalloons_cutout(this: ICharlesDickensCutouts_dicBalloons_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [112.95,-14.10,161.60,-7.80,200.80,16.50,222.75,53.35,232.20,100.40,224.35,153.75,199.25,201.60,169.45,230.60,131.80,244.70,131.00,269.80,105.10,274.50,83.15,268.25,77.65,243.15,36.90,226.65,4.75,190.60,-10.20,152.20,-11.00,100.40,3.15,54.95,29.00,17.30,46.65,6.90,64.35,-2.30];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBalloons.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 217.00;
	sprite.height = 263.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol3(this: ICharlesDickensCutouts_Symbol3) {
	return this;
}
function CharlesDickensCutouts_dicBalloons(this: ICharlesDickensCutouts_dicBalloons) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-balloons.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBanana_cutout(this: ICharlesDickensCutouts_dicBanana_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [178.60,8.85,203.10,2.00,232.55,2.00,234.50,39.25,220.80,56.90,189.40,57.90,164.85,54.00,104.70,92.35,85.75,124.35,81.15,162.20,86.40,199.85,88.35,223.70,81.45,239.40,55.95,243.30,19.65,225.65,-8.80,177.20,-13.60,117.30,3.95,58.85,34.20,16.65,76.55,-8.80,110.95,-12.75,152.10,-6.85];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBanana.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 224.00;
	sprite.height = 233.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol4(this: ICharlesDickensCutouts_Symbol4) {
	return this;
}
function CharlesDickensCutouts_dicBanana(this: ICharlesDickensCutouts_dicBanana) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-banana.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBaseballField_cutout(this: ICharlesDickensCutouts_dicBaseballField_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [108.50,85.35,254.50,36.70,344.30,7.75,435.50,10.40,508.85,4.00,576.65,4.80,650.05,3.20,711.25,0.60,792.05,3.20,910.90,-0.80,944.40,0.80,999.40,-1.60,1043.30,2.40,1091.95,-1.60,1155.75,3.20,1240.30,4.80,1308.95,0.05,1393.50,3.20,1465.30,6.40,1500.40,3.20,1548.25,8.80,1634.40,7.20,1657.50,10.40,1677.45,17.55,1762.80,45.50,1832.20,65.45,1903.20,93.35,1962.20,114.10,1987.75,122.10,2007.70,138.85,-14.70,153.05,-8.85,140.05,-2.35,127.65];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBaseballField.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1996.72;
	sprite.height = 253.20;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol5(this: ICharlesDickensCutouts_Symbol5) {
	return this;
}
function CharlesDickensCutouts_dicBaseballField(this: ICharlesDickensCutouts_dicBaseballField) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-baseball-field.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBaseballLights_cutout(this: ICharlesDickensCutouts_dicBaseballLights_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [52.85,-10.45,119.05,-7.05,167.85,-8.10,237.05,-4.00,278.75,-4.00,286.35,10.25,292.95,57.95,292.00,85.50,293.40,110.95,282.75,124.10,252.75,125.15,250.30,271.50,219.25,274.65,214.70,244.20,214.65,173.90,189.65,214.15,186.70,264.90,154.65,267.60,125.15,267.60,92.60,266.00,86.50,242.15,86.50,201.45,61.55,161.20,61.10,214.70,55.90,263.95,26.95,264.40,23.45,228.95,24.45,115.00,-4.05,112.95,-13.20,98.70,-11.20,18.35,-7.00,6.55,-2.00,-6.05];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBaseballLights.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 290.00;
	sprite.height = 266.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol6(this: ICharlesDickensCutouts_Symbol6) {
	return this;
}
function CharlesDickensCutouts_dicBaseballLights(this: ICharlesDickensCutouts_dicBaseballLights) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-baseball-lights.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBBaseball_cutout(this: ICharlesDickensCutouts_dicBBaseball_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [248.15,-12.25,284.05,-11.25,295.30,1.05,337.35,10.30,383.50,36.95,412.20,68.75,435.75,111.80,435.75,150.75,436.80,214.35,452.15,226.65,461.40,260.45,449.10,300.45,419.35,328.15,380.40,327.10,327.10,364.95,356.85,464.45,382.50,484.95,401.95,527.00,398.90,566.95,378.40,597.70,340.45,606.95,338.35,636.65,321.95,656.15,283.00,669.45,239.90,674.60,207.10,666.40,190.70,660.25,149.70,655.15,122.05,643.85,111.70,609.90,123.05,581.35,149.70,572.10,143.55,554.65,151.75,500.35,148.65,469.95,154.85,428.55,107.65,427.55,55.40,406.00,44.10,385.50,9.25,375.30,-11.25,344.50,-10.00,302.55,11.30,274.80,34.90,267.60,32.85,237.90,46.15,210.20,64.60,204.05,65.65,148.70,63.60,118.95,79.40,73.70,138.45,22.55,185.60,5.15,208.40,2.20,232.75,0.05];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBBaseball.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 446.00;
	sprite.height = 662.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol7(this: ICharlesDickensCutouts_Symbol7) {
	return this;
}
function CharlesDickensCutouts_dicBBaseball(this: ICharlesDickensCutouts_dicBBaseball) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-baseball.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBButterfly_cutout(this: ICharlesDickensCutouts_dicBButterfly_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [210.90,15.70,212.70,41.90,199.40,99.80,250.45,110.40,289.80,122.95,338.60,171.35,360.85,229.05,381.45,238.10,391.30,260.35,389.65,294.10,365.80,326.25,347.65,375.60,313.05,419.25,334.50,473.40,336.05,509.45,323.65,528.00,294.10,528.80,298.25,579.85,290.80,616.95,300.70,649.90,327.05,656.50,340.25,675.40,336.95,701.80,320.45,721.60,252.90,724.05,215.00,738.90,161.45,733.10,126.05,721.55,120.25,703.45,121.10,674.60,106.30,659.25,108.75,537.05,88.95,522.05,83.85,495.20,94.75,467.00,105.45,448.10,66.75,415.95,33.80,416.80,0.05,397.85,-13.15,365.75,-10.65,329.50,7.45,308.05,4.15,268.55,14.85,219.15,38.70,174.65,70.05,144.15,96.40,131.80,67.55,119.45,63.45,89.00,72.50,59.35,94.75,49.45,101.35,27.20,135.90,14.00,154.85,-9.85,170.60,-10.05,187.05,-9.00];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBButterfly.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 378.00;
	sprite.height = 724.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol8(this: ICharlesDickensCutouts_Symbol8) {
	return this;
}
function CharlesDickensCutouts_dicBButterfly(this: ICharlesDickensCutouts_dicBButterfly) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-butterfly.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBCircus_cutout(this: ICharlesDickensCutouts_dicBCircus_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [334.15,-0.80,385.55,34.85,411.25,82.10,420.40,136.85,417.90,169.15,431.60,176.95,437.85,207.70,427.00,240.50,404.65,258.70,383.90,261.20,363.20,286.05,339.15,302.65,370.65,312.60,377.30,330.00,377.30,382.50,361.80,397.75,315.35,400.50,298.20,430.90,293.55,477.60,344.15,480.90,368.15,499.95,372.30,532.30,357.40,569.60,328.35,594.50,290.65,609.45,256.65,597.15,250.45,560.50,212.30,507.45,186.60,527.35,153.40,532.30,136.85,529.00,123.55,548.90,96.20,557.20,64.70,547.25,50.60,521.50,55.40,481.60,101.85,435.95,142.60,435.35,152.60,373.95,161.70,341.60,120.25,342.40,86.25,328.30,41.50,330.80,11.65,334.10,-9.90,331.65,-9.90,305.95,5.85,279.40,38.20,267.80,76.30,262.00,57.25,237.95,53.10,205.60,59.75,179.90,75.05,163.75,82.10,102.85,110.30,46.45,157.00,9.95,218.90,-10.75,263.70,-14.90];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBCircus.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 424.00;
	sprite.height = 595.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol9(this: ICharlesDickensCutouts_Symbol9) {
	return this;
}
function CharlesDickensCutouts_dicBCircus(this: ICharlesDickensCutouts_dicBCircus) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-circus.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBConcerned_cutout(this: ICharlesDickensCutouts_dicBConcerned_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [255.75,-7.30,314.55,15.40,351.25,63.50,370.25,125.15,370.65,179.00,388.00,187.70,393.25,221.00,384.00,249.70,362.00,270.40,337.25,273.75,329.95,292.45,341.25,310.50,343.85,334.35,331.95,362.55,311.90,384.60,284.50,401.95,259.15,403.95,260.45,456.10,256.45,489.45,251.10,512.15,261.75,530.20,283.80,538.20,299.15,551.55,301.15,580.30,287.80,601.00,257.10,605.65,219.70,605.00,188.30,617.00,142.90,620.35,102.15,611.00,80.15,595.65,82.80,548.25,70.10,536.90,69.45,509.50,74.15,440.05,55.45,421.10,49.85,390.15,58.10,357.90,87.50,331.90,92.85,317.85,62.10,286.45,25.40,282.45,-2.00,265.75,-12.65,231.70,-10.65,200.30,9.10,172.50,15.80,113.90,38.10,60.15,74.15,24.10,124.90,-1.95,170.95,-14.00,209.70,-14.00];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBConcerned.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 380.00;
	sprite.height = 606.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol10(this: ICharlesDickensCutouts_Symbol10) {
	return this;
}
function CharlesDickensCutouts_dicBConcerned(this: ICharlesDickensCutouts_dicBConcerned) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-concerned.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBeanbag_cutout(this: ICharlesDickensCutouts_dicBeanbag_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [523.80,-7.50,579.90,6.70,634.25,34.35,693.65,88.70,717.05,132.25,752.25,143.05,787.40,170.65,810.85,218.35,814.15,251.85,845.95,272.75,882.80,325.50,897.90,385.25,894.90,443.95,871.90,518.75,821.70,594.90,758.95,633.40,669.25,656.35,443.95,664.45,346.40,665.20,266.10,666.90,169.90,656.00,102.10,631.75,46.85,593.25,7.55,527.15,-12.50,439.25,-12.00,361.55,19.25,263.55,89.55,184.95,163.05,152.30,182.65,116.65,206.70,97.90,243.55,86.20,282.80,44.35,332.15,12.55,399.95,-5.85,472.75,-14.20];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBeanbag.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 884.00;
	sprite.height = 652.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol11(this: ICharlesDickensCutouts_Symbol11) {
	return this;
}
function CharlesDickensCutouts_dicBeanbag(this: ICharlesDickensCutouts_dicBeanbag) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-beanbag.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBed_cutout(this: ICharlesDickensCutouts_dicBed_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1133.80,32.05,1140.30,50.50,1228.20,23.35,1234.70,7.65,1261.30,-10.80,1302.00,-10.25,1318.80,-2.15,1327.85,167.20,1323.70,327.10,1320.45,407.95,1322.65,481.20,1325.90,539.80,1317.20,563.65,1280.30,570.15,1254.30,565.80,1236.90,552.25,1229.85,528.35,1140.90,527.80,1138.75,545.20,1088.25,548.45,1063.30,541.95,1050.85,531.10,689.85,528.80,483.30,525.60,412.30,523.50,166.10,530.25,153.90,545.80,124.20,551.40,90.35,549.65,62.55,571.80,12.15,572.65,-7.80,567.05,-13.45,547.50,-12.15,408.10,-14.40,84.00,-4.20,-7.65,63.65,-6.80,81.50,4.25,87.45,30.55,110.20,30.25,146.70,32.70,168.60,41.05,168.45,249.20,234.35,257.40,287.95,252.65,368.75,252.00,457.70,250.65,501.20,254.05,579.30,249.95,630.25,245.20,701.55,250.60,769.45,256.75,807.50,256.75,870.65,249.25,867.05,225.00,869.10,190.40,867.25,169.80,868.65,156.60,880.75,148.70,909.35,150.10,934.95,138.75,980.35,133.10,1027.05,139.45,1030.20,127.00,1028.95,89.80,1049.90,83.55,1050.60,53.65,1072.60,26.85];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBed.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1314.00;
	sprite.height = 560.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol12(this: ICharlesDickensCutouts_Symbol12) {
	return this;
}
function CharlesDickensCutouts_dicBed(this: ICharlesDickensCutouts_dicBed) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-bed.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBExcited_cutout(this: ICharlesDickensCutouts_dicBExcited_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [230.00,-12.15,277.60,0.00,314.65,22.15,347.80,68.05,362.70,108.95,367.65,146.55,367.65,171.95,382.60,178.05,390.90,205.15,383.15,240.00,361.05,261.55,335.60,267.60,299.10,310.75,325.65,329.00,335.25,346.65,336.20,382.70,318.45,406.40,305.75,413.05,288.05,428.50,268.15,434.05,268.15,481.60,258.00,502.70,269.80,526.40,295.80,535.80,308.00,551.25,310.20,574.50,302.45,592.20,279.80,603.25,246.05,607.10,225.05,603.80,190.25,617.65,147.65,618.75,105.65,609.35,84.10,593.30,87.95,540.20,75.25,531.40,71.90,518.10,79.10,420.25,57.00,403.65,50.35,380.40,53.70,351.65,71.95,329.00,90.20,314.60,62.55,288.60,30.45,289.15,2.25,273.65,-12.15,239.40,-10.45,204.55,10.55,179.65,11.10,128.80,29.90,72.95,59.75,34.85,104.55,7.20,140.65,-3.40,177.50,-12.70];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBExcited.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 376.00;
	sprite.height = 605.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol13(this: ICharlesDickensCutouts_Symbol13) {
	return this;
}
function CharlesDickensCutouts_dicBExcited(this: ICharlesDickensCutouts_dicBExcited) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-excited.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBFlying_cutout(this: ICharlesDickensCutouts_dicBFlying_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [839.85,-0.40,893.40,26.80,928.15,56.20,951.80,112.85,954.05,165.95,944.20,213.70,933.50,236.90,937.65,263.60,922.80,298.50,900.95,312.75,883.95,318.15,939.35,352.10,1025.90,416.95,1096.75,490.55,1148.55,554.60,1144.00,582.30,1118.10,581.00,1104.95,570.05,1028.15,545.05,944.15,528.25,932.80,536.00,909.20,534.15,901.90,519.15,854.25,500.10,808.80,495.10,790.95,505.35,767.00,504.05,758.05,475.55,733.65,448.10,702.80,435.95,687.15,435.35,678.80,424.20,682.15,394.60,677.10,375.65,665.40,374.50,660.90,392.40,648.10,403.55,617.40,407.45,608.45,427.55,576.65,430.35,552.60,436.50,526.95,432.60,516.90,417.50,513.30,392.05,502.60,392.65,492.90,417.50,468.90,434.25,435.40,430.95,410.80,414.20,400.75,386.85,404.70,360.60,420.85,338.80,385.10,336.35,352.20,341.05,343.85,346.65,323.20,346.10,309.20,322.65,258.45,290.25,180.30,267.40,175.90,231.10,140.15,175.30,80.40,122.80,24.00,82.05,-5.55,77.60,-10.05,48.55,8.40,39.10,92.70,33.00,176.95,42.45,251.15,58.65,367.30,92.70,430.35,113.35,497.45,138.45,510.20,160.25,547.65,178.70,550.40,151.30,564.90,125.05,588.90,115.60,614.60,56.95,641.95,22.90,695.00,-5.00,741.35,-13.95,788.50,-12.70];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBFlying.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1136.00;
	sprite.height = 574.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol14(this: ICharlesDickensCutouts_Symbol14) {
	return this;
}
function CharlesDickensCutouts_dicBFlying(this: ICharlesDickensCutouts_dicBFlying) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-flying.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBHome_cutout(this: ICharlesDickensCutouts_dicBHome_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [335.90,-9.75,347.80,0.00,352.90,11.20,437.15,35.85,437.50,75.25,457.75,110.25,470.40,162.70,470.75,194.15,466.05,217.30,481.60,240.80,506.20,247.65,529.35,265.75,532.25,287.45,523.55,312.75,510.90,317.45,499.35,335.20,476.90,337.00,459.55,330.50,428.10,330.10,406.40,371.70,380.35,402.45,358.70,414.05,338.80,418.35,316.00,414.40,300.80,401.00,287.45,384.00,260.70,383.65,215.85,372.80,181.50,377.85,113.85,368.10,90.75,390.50,70.85,397.00,47.35,394.50,24.95,381.10,1.10,346.05,-9.70,321.05,-14.40,288.50,-5.40,243.30,12.65,219.10,41.60,203.20,69.45,203.55,85.00,210.40,98.00,174.60,86.45,151.85,69.10,143.90,63.30,117.45,68.70,78.80,94.40,74.45,105.85,56.40,137.65,58.80,143.20,93.35,169.25,47.05,198.85,25.10,206.70,-2.95,232.45,-4.30,291.55,1.30,311.65,-11.90];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBHome.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 520.00;
	sprite.height = 404.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol15(this: ICharlesDickensCutouts_Symbol15) {
	return this;
}
function CharlesDickensCutouts_dicBHome(this: ICharlesDickensCutouts_dicBHome) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-home.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBlanket_cutout(this: ICharlesDickensCutouts_dicBlanket_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [358.10,12.15,428.60,15.70,514.70,11.45,548.70,1.95,578.30,1.00,611.50,9.30,650.65,-4.25,691.95,-13.50,741.80,-12.10,775.90,0.05,802.95,12.85,838.55,15.70,863.45,24.95,881.25,34.20,902.75,38.60,914.75,90.45,919.75,122.45,948.25,153.05,968.85,191.50,979.20,219.00,978.45,259.15,980.95,288.35,963.65,304.05,938.50,301.45,921.60,293.80,845.80,307.85,754.55,310.35,505.40,298.25,439.95,289.05,375.85,276.25,346.60,268.45,187.95,286.20,122.70,299.55,75.45,303.25,34.90,292.60,2.35,291.95,-11.95,276.00,-10.25,252.00,-2.15,243.45,4.30,212.15,28.00,178.25,67.65,153.05,79.05,115.35,104.70,86.90,148.10,71.95,155.95,35.65,190.85,22.10,238.50,5.00,275.55,3.60];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBlanket.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 970.00;
	sprite.height = 296.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol16(this: ICharlesDickensCutouts_Symbol16) {
	return this;
}
function CharlesDickensCutouts_dicBlanket(this: ICharlesDickensCutouts_dicBlanket) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-blanket.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBLaying_cutout(this: ICharlesDickensCutouts_dicBLaying_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [492.25,-2.10,538.35,27.40,583.65,75.60,623.25,154.05,628.30,221.00,604.55,278.55,572.90,324.55,527.55,359.80,498.75,368.45,482.50,385.95,452.70,397.25,401.60,439.70,370.25,445.45,337.85,431.00,278.60,454.40,198.65,464.20,126.70,463.45,46.00,452.30,42.05,442.40,17.00,434.90,0.00,403.70,2.20,371.35,-11.50,350.45,-9.90,313.05,27.35,296.90,36.75,279.20,80.65,275.60,104.55,256.20,139.65,251.85,167.00,262.65,187.85,242.70,211.30,235.20,241.85,235.30,231.75,181.40,240.40,129.60,262.00,88.55,258.00,59.30,280.40,38.15,307.65,37.30,337.45,28.10,369.90,2.90,405.15,-11.50,441.15,-12.90];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBLaying.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 614.00;
	sprite.height = 450.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol17(this: ICharlesDickensCutouts_Symbol17) {
	return this;
}
function CharlesDickensCutouts_dicBLaying(this: ICharlesDickensCutouts_dicBLaying) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-laying.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBMuseum_cutout(this: ICharlesDickensCutouts_dicBMuseum_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [177.10,-13.30,215.95,-8.65,262.40,7.60,305.35,34.85,332.65,79.55,344.85,124.20,345.40,154.40,366.30,169.50,377.35,196.75,372.10,235.65,350.65,260.60,328.00,265.85,306.50,264.65,262.40,304.75,271.10,345.35,281.55,427.20,311.70,444.70,311.70,470.95,288.50,481.75,222.90,482.35,220.60,507.35,204.35,525.35,190.40,556.10,166.60,570.60,134.70,569.45,116.10,559.60,85.95,560.75,58.65,552.00,47.65,518.95,58.10,479.45,38.85,467.80,41.70,442.30,69.65,428.35,101.00,315.15,69.70,297.15,47.05,270.45,16.25,264.65,-1.70,247.25,-13.90,220.55,-8.10,187.45,5.85,178.75,4.10,127.15,18.00,70.85,47.05,26.70,85.90,2.90,128.90,-9.85];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBMuseum.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 362.00;
	sprite.height = 558.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol18(this: ICharlesDickensCutouts_Symbol18) {
	return this;
}
function CharlesDickensCutouts_dicBMuseum(this: ICharlesDickensCutouts_dicBMuseum) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-museum.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBowlingball_cutout(this: ICharlesDickensCutouts_dicBowlingball_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [192.40,-5.05,239.05,19.70,271.10,68.55,285.65,134.10,276.90,194.60,246.30,246.35,203.35,274.75,145.05,290.05,80.20,279.85,31.35,253.60,-4.35,198.25,-15.25,131.20,4.30,61.60,45.20,16.80,96.10,-8.30,145.50,-14.45];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBowlingball.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 270.00;
	sprite.height = 275.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol19(this: ICharlesDickensCutouts_Symbol19) {
	return this;
}
function CharlesDickensCutouts_dicBowlingball(this: ICharlesDickensCutouts_dicBowlingball) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-bowlingball.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBPointing_cutout(this: ICharlesDickensCutouts_dicBPointing_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [248.10,-8.40,302.65,13.20,345.05,51.95,368.45,117.75,369.90,179.80,388.80,192.35,398.40,223.65,391.80,258.75,381.55,273.35,377.90,305.50,388.15,320.85,386.10,350.05,340.85,393.20,285.65,411.75,289.85,478.35,283.65,493.35,294.95,536.15,317.25,549.65,322.30,573.05,316.55,595.70,280.00,611.80,243.45,611.05,211.30,601.55,195.20,589.85,165.95,605.20,125.00,608.10,90.65,599.35,72.40,581.05,71.65,552.55,85.55,535.00,85.55,516.75,68.00,507.95,60.70,485.30,64.70,462.30,73.80,450.90,96.50,377.85,103.80,328.90,59.60,291.55,24.90,290.15,-0.70,269.70,-13.55,231.60,-8.65,197.65,12.45,180.50,13.90,125.00,30.00,69.45,68.75,18.25,125.30,-7.00,184.65,-15.35];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBPointing.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 383.00;
	sprite.height = 598.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol20(this: ICharlesDickensCutouts_Symbol20) {
	return this;
}
function CharlesDickensCutouts_dicBPointing(this: ICharlesDickensCutouts_dicBPointing) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-pointing.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBScared_cutout(this: ICharlesDickensCutouts_dicBScared_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [322.10,47.20,345.70,94.40,351.30,137.95,342.75,171.75,345.70,212.30,355.95,230.45,344.70,258.80,328.80,262.00,312.45,270.30,300.55,271.80,275.05,321.80,328.00,363.30,372.05,409.90,403.90,470.05,404.70,501.15,369.25,513.65,320.60,525.45,279.35,529.85,302.95,554.20,310.30,602.10,298.50,618.30,291.15,670.65,270.50,692.00,241.00,695.70,211.55,682.45,196.80,653.70,195.35,625.70,205.65,607.25,198.30,587.35,167.30,568.20,131.20,546.80,117.20,524.70,115.00,494.50,123.85,481.25,117.20,451.00,101.75,441.45,72.25,456.90,64.90,481.25,37.60,487.15,17.70,481.55,0.00,448.80,0.75,410.45,24.35,381.75,30.25,339.70,39.10,313.20,53.10,297.70,9.60,252.75,-12.50,191.60,-11.05,117.15,17.70,48.65,69.30,0.00,123.10,-14.00,196.05,-11.05,275.65,13.30];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBScared.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 395.00;
	sprite.height = 680.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol21(this: ICharlesDickensCutouts_Symbol21) {
	return this;
}
function CharlesDickensCutouts_dicBScared(this: ICharlesDickensCutouts_dicBScared) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-scared.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBSea_cutout(this: ICharlesDickensCutouts_dicBSea_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [285.80,-5.05,337.70,17.80,383.90,69.35,401.05,116.05,408.15,168.20,405.20,201.95,424.75,220.35,427.70,258.25,412.90,293.20,386.25,313.95,366.70,318.70,350.10,318.70,327.50,341.25,300.10,360.30,307.50,398.70,334.75,451.90,339.50,475.70,349.55,517.75,344.80,546.20,321.10,558.05,325.30,584.10,336.55,604.25,351.70,626.55,353.85,658.05,341.30,680.70,309.90,688.40,280.25,683.05,262.50,670.60,248.85,651.05,206.55,640.50,192.60,681.25,171.25,699.65,133.95,703.20,109.65,694.30,93.05,676.55,89.50,644.55,103.10,616.70,97.20,599.55,48.05,582.95,45.05,556.30,74.70,501.20,106.70,407.00,76.45,369.05,63.45,347.75,62.85,318.70,45.65,291.45,17.20,284.95,-6.50,259.50,-15.40,222.75,-7.70,185.40,5.95,171.80,18.95,168.85,26.65,111.40,49.75,51.60,112.00,3.60,168.75,-13.15,226.10,-15.35];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBSea.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 413.00;
	sprite.height = 689.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol22(this: ICharlesDickensCutouts_Symbol22) {
	return this;
}
function CharlesDickensCutouts_dicBSea(this: ICharlesDickensCutouts_dicBSea) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-sea.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBSittingconfused_cutout(this: ICharlesDickensCutouts_dicBSittingconfused_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [256.80,-9.50,306.85,10.15,337.20,34.90,363.40,82.25,374.70,147.20,373.50,187.10,389.00,198.45,393.80,227.05,383.65,255.65,357.45,277.60,332.45,281.75,304.45,311.55,272.75,331.30,305.65,446.20,337.20,464.45,338.35,492.95,316.95,505.20,327.70,524.25,328.90,551.65,316.40,577.85,288.40,588.60,262.75,585.00,235.95,598.10,201.40,596.35,185.30,587.40,164.45,546.30,149.55,527.80,148.40,503.40,82.80,505.20,52.45,493.25,52.45,462.90,84.60,448.60,100.10,339.60,105.45,319.30,81.05,297.90,64.35,275.85,32.80,278.80,5.35,266.90,-13.10,232.30,-13.35,198.75,2.10,171.40,16.70,163.80,20.85,118.00,44.10,56.65,95.95,10.75,145.40,-8.30,199.60,-14.30];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBSittingconfused.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 379.00;
	sprite.height = 584.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol23(this: ICharlesDickensCutouts_Symbol23) {
	return this;
}
function CharlesDickensCutouts_dicBSittingconfused(this: ICharlesDickensCutouts_dicBSittingconfused) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-sittingconfused.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicBSpace_cutout(this: ICharlesDickensCutouts_dicBSpace_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [510.65,-9.30,573.60,14.10,589.55,43.25,589.55,79.95,568.90,106.25,547.90,137.30,590.45,131.65,615.85,133.55,644.05,147.65,659.10,186.20,647.80,247.30,624.30,299.00,590.45,307.45,611.15,363.85,609.75,389.70,566.95,396.80,542.85,412.85,535.00,436.25,503.05,436.25,491.75,428.75,461.65,427.80,449.45,412.75,455.05,383.60,423.10,349.75,411.80,423.10,378.95,486.10,321.60,537.80,249.20,564.15,178.70,565.05,101.60,532.15,37.60,471.95,-3.75,388.30,-16.00,324.35,-7.50,250.05,31.05,174.90,109.10,119.45,184.30,98.75,253.90,103.45,310.30,126.00,298.05,88.40,275.10,79.70,273.60,53.60,287.70,40.45,290.50,13.20,321.55,5.65,351.10,-0.25,368.55,16.00,388.35,22.60,392.15,50.45,383.65,68.65,399.60,121.30,443.80,95.00,419.35,71.50,412.80,39.50,423.10,1.90,451.35,-13.15];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicBSpace.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 645.00;
	sprite.height = 552.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol24(this: ICharlesDickensCutouts_Symbol24) {
	return this;
}
function CharlesDickensCutouts_dicBSpace(this: ICharlesDickensCutouts_dicBSpace) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-space.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicButterflyB_cutout(this: ICharlesDickensCutouts_dicButterflyB_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [77.35,24.65,115.55,34.95,132.00,45.10,133.00,73.30,115.10,93.40,100.50,98.05,87.90,111.15,66.05,119.90,42.75,117.95,34.50,111.65,29.40,101.90,13.15,101.15,-5.60,85.35,-11.60,31.55,-8.70,1.00,2.45,-10.20,12.50,-10.10,22.35,-10.20];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicButterflyB.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 125.00;
	sprite.height = 109.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol25(this: ICharlesDickensCutouts_Symbol25) {
	return this;
}
function CharlesDickensCutouts_dicButterflyB(this: ICharlesDickensCutouts_dicButterflyB) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-b.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicButterflyBack_cutout(this: ICharlesDickensCutouts_dicButterflyBack_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [1102.80,189.75,1086.85,233.65,1071.55,257.45,1111.60,244.10,1136.80,245.75,1137.40,271.10,1103.05,312.75,1064.85,337.00,1032.50,351.90,1067.60,394.90,1105.90,458.55,1123.05,524.30,1131.65,600.60,1170.10,628.40,1183.10,656.90,1195.50,682.60,1189.70,711.70,1170.45,726.40,1160.25,738.85,1143.85,741.65,1089.80,734.80,1022.95,740.75,970.50,739.80,920.45,741.15,849.65,737.35,791.95,741.80,783.65,730.35,666.95,725.90,604.70,720.75,525.05,724.05,492.90,717.05,389.00,722.65,363.40,736.95,292.60,734.75,259.35,724.60,197.10,724.60,110.15,714.75,76.90,714.80,19.10,716.95,7.85,708.35,9.55,689.30,35.30,649.25,11.50,640.65,4.80,604.45,23.85,592.05,-13.30,559.60,-10.45,528.15,43.90,529.10,36.20,499.55,42.40,475.95,70.60,473.80,89.65,486.20,108.85,429.75,144.00,385.10,174.50,358.40,236.45,339.35,191.65,336.50,155.45,337.45,131.60,330.80,59.15,258.30,14.80,238.25,12.45,207.85,89.65,182.10,170.70,172.60,224.10,181.15,191.70,125.85,160.20,70.55,159.25,43.85,244.10,44.85,297.45,57.20,326.90,67.70,368.95,116.35,402.35,174.50,435.70,119.20,460.50,73.45,503.35,53.45,566.30,37.20,642.55,8.60,683.55,-11.40,711.20,-7.60,712.15,17.20,673.05,62.95,607.30,118.25,582.50,141.15,567.25,174.50,610.15,162.10,628.25,162.10,686.45,191.65,731.25,210.70,769.35,232.65,825.60,245.05,832.30,269.85,787.50,278.40,724.55,301.30,659.75,307.95,720.75,315.60,783.70,367.05,816.10,328.00,843.75,307.00,869.50,303.20,851.35,268.85,852.30,240.25,880.95,239.30,911.45,265.05,920.85,250.40,946.70,247.90,966.60,280.85,988.65,230.75,1027.70,184.05,1076.35,165.00,1101.15,165.95];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicButterflyBack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1185.00;
	sprite.height = 730.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol26(this: ICharlesDickensCutouts_Symbol26) {
	return this;
}
function CharlesDickensCutouts_dicButterflyBack(this: ICharlesDickensCutouts_dicButterflyBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-back.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicButterflyFront_cutout(this: ICharlesDickensCutouts_dicButterflyFront_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [45.25,-11.80,63.35,-3.55,90.85,-2.05,106.20,7.90,131.40,14.55,146.70,32.25,146.95,58.90,137.65,77.50,115.50,91.50,92.05,99.50,85.50,110.55,62.95,112.90,40.15,107.40,7.50,69.65,-11.00,41.30,-11.00,16.95,-3.20,3.45,9.05,-0.15,23.25,-11.00];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicButterflyFront.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 135.00;
	sprite.height = 105.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol27(this: ICharlesDickensCutouts_Symbol27) {
	return this;
}
function CharlesDickensCutouts_dicButterflyFront(this: ICharlesDickensCutouts_dicButterflyFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-front.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicButterflyR_cutout(this: ICharlesDickensCutouts_dicButterflyR_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [83.80,29.05,98.00,29.55,149.20,-9.80,178.25,-10.80,189.55,3.50,194.50,30.55,187.60,72.90,188.05,99.95,180.15,121.60,163.90,140.65,143.75,144.00,124.30,139.85,116.15,156.10,102.00,163.85,77.10,165.15,56.60,153.60,40.85,141.80,32.50,124.10,17.25,117.70,-10.80,82.20,-10.80,58.60,2.95,45.30,34.00,38.90,69.80,41.60];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicButterflyR.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 181.00;
	sprite.height = 154.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol28(this: ICharlesDickensCutouts_Symbol28) {
	return this;
}
function CharlesDickensCutouts_dicButterflyR(this: ICharlesDickensCutouts_dicButterflyR) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-r.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicButterflyY_cutout(this: ICharlesDickensCutouts_dicButterflyY_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [108.45,15.80,138.50,13.80,172.50,21.70,179.35,34.25,178.60,51.25,159.20,73.45,135.55,87.25,113.85,113.35,97.10,117.45,79.85,115.05,68.55,103.00,51.75,108.40,29.60,105.45,19.75,91.65,12.85,60.65,-7.85,25.15,-9.80,-0.45,0.55,-10.80,27.80,-11.30,64.60,5.95,90.25,5.00];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicButterflyY.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 170.00;
	sprite.height = 106.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol29(this: ICharlesDickensCutouts_Symbol29) {
	return this;
}
function CharlesDickensCutouts_dicButterflyY(this: ICharlesDickensCutouts_dicButterflyY) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-y.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCastle_cutout(this: ICharlesDickensCutouts_dicCastle_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [146.85,-7.80,163.35,15.65,154.55,63.80,230.90,74.45,270.50,88.95,304.35,114.05,304.35,148.85,262.80,141.10,208.70,153.65,155.55,147.90,157.45,392.30,212.45,394.35,275.35,436.75,288.70,435.20,287.50,263.30,277.30,241.55,282.10,219.35,307.25,209.70,338.15,221.25,338.15,249.30,385.50,267.65,458.00,307.30,464.75,333.35,427.05,344.95,380.70,345.95,333.70,333.55,334.30,510.20,370.05,512.15,420.30,539.20,424.10,597.00,411.60,628.10,593.45,633.60,593.80,539.65,571.50,451.70,582.85,375.50,688.95,384.60,688.00,49.30,678.90,28.05,682.80,0.00,709.25,-14.50,746.00,-1.95,752.75,33.85,745.00,49.30,808.80,67.65,883.20,130.45,880.30,157.50,819.45,156.55,771.10,141.10,740.60,139.85,742.45,385.55,787.55,383.65,825.20,404.90,825.20,265.75,818.05,238.10,828.30,215.20,863.90,211.55,880.30,230.00,873.55,258.00,929.55,280.25,994.15,297.30,1003.45,325.65,968.20,338.20,919.90,349.80,874.50,340.15,874.50,507.30,911.25,510.20,959.95,536.25,962.15,604.40,950.85,631.00,1001.10,661.90,1001.10,732.45,946.75,741.15,946.00,800.10,948.70,888.65,947.90,961.45,961.45,1023.30,798.15,1135.40,709.25,1136.35,597.15,1135.40,581.70,1120.90,265.80,1121.85,226.95,1139.25,199.10,1140.20,75.40,1141.20,13.55,1133.45,-3.80,1116.05,-4.80,1085.15,10.65,1054.20,7.80,997.25,17.45,862.90,7.75,744.05,11.65,635.80,9.70,545.00,-10.95,446.10,-0.15,392.00,104.00,395.75,105.35,50.30,93.75,34.85,94.70,2.95,110.00,-9.35];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCastle.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 992.00;
	sprite.height = 1132.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol30(this: ICharlesDickensCutouts_Symbol30) {
	return this;
}
function CharlesDickensCutouts_dicCastle(this: ICharlesDickensCutouts_dicCastle) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-castle.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens1_cutout(this: ICharlesDickensCutouts_dicChickens1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [45.15,27.00,74.60,40.15,84.00,67.70,132.90,62.10,144.80,39.50,156.10,8.20,169.25,-8.75,196.85,-8.15,204.35,13.20,220.05,20.10,221.30,52.70,228.15,64.60,219.40,139.80,194.95,164.20,177.35,184.55,170.50,208.65,174.20,240.05,161.95,246.30,109.10,246.95,90.30,243.80,87.80,230.65,46.40,224.40,48.95,190.55,27.75,175.10,6.95,141.65,6.30,114.05,-8.75,107.15,-8.75,81.85,3.80,72.70,6.95,40.10,19.45,30.75];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 215.00;
	sprite.height = 237.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol31(this: ICharlesDickensCutouts_Symbol31) {
	return this;
}
function CharlesDickensCutouts_dicChickens1(this: ICharlesDickensCutouts_dicChickens1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens2_cutout(this: ICharlesDickensCutouts_dicChickens2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [60.70,-6.80,75.95,13.30,88.00,58.70,149.45,74.75,159.10,62.70,182.00,53.45,204.50,29.35,223.40,21.35,251.50,26.15,257.35,86.50,245.85,107.30,242.20,131.00,226.55,149.85,223.35,162.75,208.50,171.95,201.65,187.20,174.35,198.00,166.70,228.15,172.70,239.80,171.10,264.30,108.85,268.75,49.00,255.05,43.80,250.25,44.20,227.75,57.45,217.30,39.00,197.60,0.80,169.50,-13.65,133.75,-9.60,95.55,-3.20,70.65,0.40,37.40,8.45,19.35,19.30,12.90,32.55,-8.80];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 246.00;
	sprite.height = 258.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol32(this: ICharlesDickensCutouts_Symbol32) {
	return this;
}
function CharlesDickensCutouts_dicChickens2(this: ICharlesDickensCutouts_dicChickens2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens3_cutout(this: ICharlesDickensCutouts_dicChickens3_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [59.45,-5.00,76.05,9.60,81.10,28.70,99.45,37.05,107.80,57.90,99.40,77.30,71.55,105.75,45.85,111.80,21.45,105.70,-3.50,77.55,-11.55,65.45,2.55,8.05,33.30,-9.05];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 100.00;
	sprite.height = 104.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol33(this: ICharlesDickensCutouts_Symbol33) {
	return this;
}
function CharlesDickensCutouts_dicChickens3(this: ICharlesDickensCutouts_dicChickens3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens4_cutout(this: ICharlesDickensCutouts_dicChickens4_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [187.50,-9.65,196.75,7.30,215.30,10.95,225.40,41.60,236.70,48.05,250.80,126.95,233.05,154.40,221.75,187.45,193.95,214.05,191.15,223.35,195.60,258.40,135.50,260.85,82.70,248.35,79.05,220.90,66.55,219.70,58.10,248.35,29.45,249.15,19.80,226.15,0.85,218.50,-10.05,202.40,-9.25,180.60,0.05,160.85,18.60,149.15,36.70,123.75,78.65,104.80,142.75,77.75,148.85,12.90,159.65,-10.05];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 237.00;
	sprite.height = 251.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol34(this: ICharlesDickensCutouts_Symbol34) {
	return this;
}
function CharlesDickensCutouts_dicChickens4(this: ICharlesDickensCutouts_dicChickens4) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-4.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens5_cutout(this: ICharlesDickensCutouts_dicChickens5_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [151.45,41.90,177.65,29.80,195.35,9.60,216.55,-0.50,238.70,2.30,244.25,11.85,244.10,30.20,248.85,59.65,236.40,84.55,233.70,108.55,220.05,120.85,214.20,136.50,202.45,143.85,194.75,159.70,167.75,170.10,162.00,195.75,166.60,208.40,162.95,232.70,101.00,236.70,45.45,220.05,42.45,195.80,54.55,187.20,39.40,170.60,4.05,143.35,-12.60,115.60,-12.60,80.75,0.55,44.45,16.70,30.80,15.35,-6.05,34.85,-12.60,73.05,-8.75,111.05,15.20,126.70,34.85,129.20,46.95,143.35,51.50];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens5.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 237.00;
	sprite.height = 226.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol35(this: ICharlesDickensCutouts_Symbol35) {
	return this;
}
function CharlesDickensCutouts_dicChickens5(this: ICharlesDickensCutouts_dicChickens5) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-5.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens6_cutout(this: ICharlesDickensCutouts_dicChickens6_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [133.00,-9.05,148.75,10.65,155.85,42.55,172.55,15.20,201.35,15.20,210.50,27.35,242.85,20.80,277.25,26.85,278.25,43.55,284.85,84.00,274.20,96.15,270.65,114.35,256.50,121.95,252.45,138.15,222.10,148.25,208.95,177.10,198.85,193.80,189.70,219.60,200.80,231.15,200.85,255.95,179.15,260.50,168.50,267.60,146.25,267.10,136.65,254.45,124.50,253.45,112.85,266.05,89.60,268.10,80.50,255.95,66.80,253.95,64.85,230.15,78.75,218.05,47.60,155.85,18.25,149.75,9.15,126.00,-1.50,116.90,-1.50,99.70,-12.65,85.50,-11.10,63.25,-0.50,48.10,-0.20,30.95,28.35,25.80,68.85,39.00,77.95,18.75,91.10,7.60,103.95,-9.50];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens6.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 273.00;
	sprite.height = 259.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol36(this: ICharlesDickensCutouts_Symbol36) {
	return this;
}
function CharlesDickensCutouts_dicChickens6(this: ICharlesDickensCutouts_dicChickens6) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-6.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens7_cutout(this: ICharlesDickensCutouts_dicChickens7_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [88.55,-7.75,103.15,9.75,111.90,44.75,130.05,17.55,159.55,16.90,169.95,42.50,181.30,54.50,182.85,78.45,188.65,97.60,182.20,152.40,156.60,194.20,145.60,225.65,159.55,240.25,156.40,265.10,135.25,266.90,126.15,275.25,103.10,274.30,94.05,261.30,78.45,260.65,67.35,274.60,44.40,274.95,36.00,264.55,20.95,262.75,19.95,238.40,33.40,224.65,19.15,192.90,8.15,175.05,-10.35,154.35,-13.25,127.10,-4.80,103.45,8.45,90.15,21.45,68.75,25.65,38.60,33.75,20.80,44.80,12.65,51.25,-1.90,61.95,-8.75];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens7.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 175.00;
	sprite.height = 267.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol37(this: ICharlesDickensCutouts_Symbol37) {
	return this;
}
function CharlesDickensCutouts_dicChickens7(this: ICharlesDickensCutouts_dicChickens7) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-7.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens8_cutout(this: ICharlesDickensCutouts_dicChickens8_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [62.25,-7.25,75.25,11.85,89.70,59.70,152.20,75.90,164.40,62.90,189.15,54.00,207.40,30.05,229.30,21.55,256.60,25.10,257.25,55.20,262.90,71.85,259.25,96.20,249.55,109.55,246.30,135.50,232.50,152.15,226.60,167.05,213.45,173.65,205.35,192.25,178.00,201.05,169.25,233.70,175.75,243.00,174.95,269.40,138.40,271.85,104.35,272.25,68.20,262.50,47.50,258.05,46.10,231.70,57.25,221.50,36.95,199.65,7.70,179.75,-11.75,147.30,-13.15,121.60,-3.85,76.70,0.10,43.75,8.60,22.55,20.30,14.65,34.10,-8.10];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens8.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 251.00;
	sprite.height = 263.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol38(this: ICharlesDickensCutouts_Symbol38) {
	return this;
}
function CharlesDickensCutouts_dicChickens8(this: ICharlesDickensCutouts_dicChickens8) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-8.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicChickens9_cutout(this: ICharlesDickensCutouts_dicChickens9_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [55.35,-8.10,67.55,4.10,72.95,22.05,106.40,20.85,128.95,-0.40,158.30,2.45,166.05,28.10,180.75,30.55,187.90,50.55,185.45,70.85,193.30,87.05,187.40,135.80,166.05,196.90,147.55,206.90,136.25,229.40,142.55,240.75,142.45,265.40,106.55,265.45,94.45,273.00,74.10,272.20,59.45,267.70,18.90,266.50,12.20,241.50,28.10,226.60,13.05,200.95,7.75,175.75,-10.15,144.40,-14.10,110.05,-6.80,66.45,-8.85,35.50,10.20,22.40,18.30,1.65,27.70,-8.50];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicChickens9.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 181.00;
	sprite.height = 263.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol39(this: ICharlesDickensCutouts_Symbol39) {
	return this;
}
function CharlesDickensCutouts_dicChickens9(this: ICharlesDickensCutouts_dicChickens9) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-9.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCircus_cutout(this: ICharlesDickensCutouts_dicCircus_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [618.15,-10.00,648.15,12.00,691.15,2.00,733.15,0.00,774.00,5.95,777.65,34.90,734.15,48.00,643.65,102.45,619.10,102.45,618.15,142.05,729.15,222.05,843.20,307.05,972.25,387.05,1084.25,458.10,1091.25,485.10,1187.25,479.10,1224.25,482.10,1260.25,500.10,1285.30,530.10,1298.00,563.95,1300.05,575.75,1333.35,589.05,1334.85,622.85,1311.80,631.05,1305.65,651.00,1308.25,678.65,1302.60,703.75,1307.20,719.65,1332.80,736.55,1349.70,758.60,1358.95,795.00,1356.35,829.30,1343.55,859.50,1329.20,877.45,1287.75,889.25,1241.65,893.85,1220.10,891.30,1191.95,900.00,1184.30,913.80,1165.35,918.40,1147.95,927.10,1074.70,935.85,1018.80,949.70,956.80,955.85,911.75,964.05,832.35,968.15,775.50,974.80,716.10,976.30,668.45,978.35,627.45,974.80,568.55,974.75,518.85,978.35,482.00,979.35,420.00,970.65,358.55,966.55,300.65,964.00,252.50,957.35,182.35,949.15,166.95,941.45,136.25,943.50,109.15,936.35,29.20,916.85,25.10,891.75,5.15,887.65,-7.15,875.90,1.05,854.90,-8.70,816.50,-11.75,781.15,-5.10,738.65,15.90,686.90,49.20,683.30,100.95,682.80,117.30,622.35,140.35,542.45,115.80,544.50,102.45,536.80,102.45,509.65,121.95,458.95,151.15,436.95,271.45,358.55,391.35,279.65,454.30,239.20,534.20,177.20,582.90,138.80,583.40,19.50,587.60,-9.50];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCircus.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1345.00;
	sprite.height = 966.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol40(this: ICharlesDickensCutouts_Symbol40) {
	return this;
}
function CharlesDickensCutouts_dicCircus(this: ICharlesDickensCutouts_dicCircus) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-circus.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCloud1_cutout(this: ICharlesDickensCutouts_dicCloud1_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCloud1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1067.00;
	sprite.height = 183.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicCloud1(this: ICharlesDickensCutouts_dicCloud1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-cloud-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCloud2_cutout(this: ICharlesDickensCutouts_dicCloud2_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCloud2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1190.00;
	sprite.height = 501.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicCloud2(this: ICharlesDickensCutouts_dicCloud2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-cloud-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCloud3_cutout(this: ICharlesDickensCutouts_dicCloud3_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCloud3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 918.00;
	sprite.height = 365.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicCloud3(this: ICharlesDickensCutouts_dicCloud3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-cloud-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCloudsFront_cutout(this: ICharlesDickensCutouts_dicCloudsFront_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCloudsFront.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 2957.00;
	sprite.height = 1024.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicCloudsFront(this: ICharlesDickensCutouts_dicCloudsFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-clouds-front.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicCouch_cutout(this: ICharlesDickensCutouts_dicCouch_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [682.35,-12.70,785.50,-3.15,866.45,0.00,944.20,22.25,974.35,49.20,987.05,77.75,997.15,169.65,996.55,253.90,1045.75,258.65,1080.65,276.10,1100.95,312.80,1097.10,345.85,1079.35,365.65,1064.45,465.70,1049.60,534.00,1012.45,542.65,998.15,564.90,945.00,567.05,923.60,547.40,701.40,549.00,457.05,544.25,176.20,545.85,158.65,562.35,105.55,563.20,84.00,539.40,55.60,534.75,31.05,459.20,15.90,366.50,-9.45,345.05,-12.60,298.95,11.10,269.75,58.70,250.70,103.25,250.80,101.55,161.85,112.70,66.65,139.00,32.55,169.80,19.05,236.35,7.25,399.95,-8.65,531.60,-15.85];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicCouch.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1086.00;
	sprite.height = 552.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol41(this: ICharlesDickensCutouts_Symbol41) {
	return this;
}
function CharlesDickensCutouts_dicCouch(this: ICharlesDickensCutouts_dicCouch) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-couch.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicLollipop_cutout(this: ICharlesDickensCutouts_dicLollipop_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [214.80,-15.30,262.10,0.05,291.55,33.30,303.05,78.00,293.95,124.80,271.05,168.80,220.65,208.40,176.25,216.00,133.10,208.05,34.55,333.70,-3.80,337.55,-14.05,305.60,35.85,239.10,89.55,164.95,75.45,112.55,84.40,66.40,112.20,18.90,160.15,-8.65];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicLollipop.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 288.00;
	sprite.height = 326.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol42(this: ICharlesDickensCutouts_Symbol42) {
	return this;
}
function CharlesDickensCutouts_dicLollipop(this: ICharlesDickensCutouts_dicLollipop) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-lollipop.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicMuseum_cutout(this: ICharlesDickensCutouts_dicMuseum_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [363.80,-9.95,406.85,-7.85,422.60,5.30,444.15,-1.55,465.15,2.15,485.65,-8.90,546.55,-8.90,574.40,3.15,596.45,0.00,635.80,7.90,642.65,26.80,638.95,48.30,645.80,66.15,646.30,105.55,639.50,113.40,641.60,161.70,694.10,164.35,713.55,155.40,754.50,151.75,760.80,137.55,793.85,131.25,803.30,102.90,822.20,101.85,833.75,81.90,850.05,76.15,897.80,80.35,945.10,100.30,947.20,78.25,957.15,77.70,960.30,43.60,998.10,37.80,1033.30,43.05,1040.10,67.75,1049.55,74.60,1051.65,95.05,1044.80,118.15,1052.15,140.20,1051.10,163.85,1108.35,167.50,1209.15,177.45,1269.00,184.80,1314.15,200.05,1321.00,222.10,1313.65,254.10,1292.15,299.25,1271.15,308.70,1255.90,309.75,1230.70,347.05,1283.40,351.15,1325.65,361.50,1345.75,379.10,1345.70,407.40,1328.35,433.10,1298.45,488.25,1308.05,524.70,1337.40,539.40,1338.25,563.60,1294.25,584.35,1209.15,590.10,1168.20,582.25,1128.85,577.00,1097.35,559.65,1097.35,538.15,1114.65,494.55,1063.75,502.95,953.70,508.95,737.85,511.75,703.95,508.00,729.65,569.55,723.65,590.20,689.75,604.70,609.55,613.70,535.30,608.60,481.65,592.15,469.30,579.15,471.00,558.30,486.75,550.70,504.90,503.90,481.35,462.80,363.30,465.90,234.00,456.65,244.30,480.25,237.70,499.55,203.70,511.20,130.05,522.15,48.15,516.50,6.15,499.80,-1.55,484.80,5.15,470.00,29.10,461.20,43.10,424.85,13.40,367.45,-7.45,352.60,-12.75,324.20,-4.05,303.80,49.30,289.45,108.80,284.30,74.90,268.45,56.65,237.35,48.45,204.15,54.90,177.50,112.95,161.15,242.25,151.95,333.90,148.50,330.50,42.10,327.05,18.20,329.25,1.20];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicMuseum.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1335.00;
	sprite.height = 605.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol43(this: ICharlesDickensCutouts_Symbol43) {
	return this;
}
function CharlesDickensCutouts_dicMuseum(this: ICharlesDickensCutouts_dicMuseum) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-museum.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicPopcorn_cutout(this: ICharlesDickensCutouts_dicPopcorn_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [752.75,-6.70,767.95,11.85,795.75,19.40,815.15,51.45,834.55,67.50,862.35,63.25,904.50,78.45,915.45,91.10,917.15,115.55,942.45,124.80,950.05,153.45,973.65,164.35,989.65,222.55,1009.05,251.20,1040.25,261.30,1084.10,293.35,1083.25,365.00,1069.75,391.15,1084.10,404.60,1089.15,440.85,1109.40,458.60,1118.65,480.50,1132.15,494.00,1132.15,523.50,1125.40,537.80,1138.05,553.85,1139.75,580.80,1159.95,595.15,1192.00,602.75,1198.75,624.65,1198.75,660.05,1148.15,671.85,1115.30,665.95,1072.30,669.30,1030.15,661.70,1003.15,660.90,971.15,666.80,940.80,669.30,923.90,683.65,885.15,690.40,840.45,684.50,837.10,659.20,827.80,635.60,826.15,607.75,816.85,612.85,808.45,653.30,774.70,673.50,748.55,678.60,707.25,662.55,688.70,653.30,678.60,621.25,650.80,611.15,641.55,640.65,604.45,653.30,563.95,649.10,530.25,629.70,528.55,603.55,501.60,605.25,517.60,626.35,517.60,659.20,510.85,671.85,478.80,676.05,462.80,687.05,417.25,681.95,402.95,652.45,354.90,654.15,317.35,633.25,316.95,590.30,220.35,590.15,233.55,608.70,232.00,643.40,204.80,658.35,185.95,670.45,125.50,669.80,110.45,660.10,104.55,635.65,69.15,644.05,24.45,647.45,-7.55,640.70,-12.65,602.75,-5.05,562.90,25.30,554.70,57.35,543.75,106.25,554.70,113.80,615.40,130.70,594.30,153.45,569.05,150.05,549.65,154.30,527.70,173.70,515.90,186.05,493.50,202.35,487.25,214.15,450.15,226.75,433.30,238.60,431.60,242.80,405.50,267.25,391.15,298.45,382.70,305.20,359.95,323.75,343.90,328.80,320.30,338.95,304.30,331.30,282.40,333.85,257.95,349.00,243.60,363.35,217.45,376.85,209.90,376.00,177.85,406.35,149.20,451.00,144.20,479.65,150.10,502.40,142.50,520.10,142.50,521.80,119.75,539.50,98.65,565.65,96.15,596.85,102.05,591.80,80.10,590.95,56.50,610.30,32.90,644.90,27.00,662.60,33.75,674.35,9.30,687.00,-5.90,720.75,-11.75];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicPopcorn.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1188.00;
	sprite.height = 678.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol44(this: ICharlesDickensCutouts_Symbol44) {
	return this;
}
function CharlesDickensCutouts_dicPopcorn(this: ICharlesDickensCutouts_dicPopcorn) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicPopcorn1_cutout(this: ICharlesDickensCutouts_dicPopcorn1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [76.45,-6.15,102.40,21.15,107.15,38.20,113.30,46.40,116.35,66.05,94.25,90.70,51.20,103.00,21.20,101.65,2.10,92.10,0.75,71.65,-10.20,44.35,-8.85,17.75,8.65,-5.80,39.60,-12.95];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicPopcorn1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 107.00;
	sprite.height = 91.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol45(this: ICharlesDickensCutouts_Symbol45) {
	return this;
}
function CharlesDickensCutouts_dicPopcorn1(this: ICharlesDickensCutouts_dicPopcorn1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicPopcorn2_cutout(this: ICharlesDickensCutouts_dicPopcorn2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [71.55,-6.55,83.85,6.40,89.40,26.85,97.75,36.60,95.60,61.15,74.35,79.25,39.90,86.30,-0.05,80.75,-7.10,57.35,-12.55,36.05,-4.35,9.30,17.50,-5.45,53.00,-10.90];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicPopcorn2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 88.00;
	sprite.height = 73.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol46(this: ICharlesDickensCutouts_Symbol46) {
	return this;
}
function CharlesDickensCutouts_dicPopcorn2(this: ICharlesDickensCutouts_dicPopcorn2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicPopcorn3_cutout(this: ICharlesDickensCutouts_dicPopcorn3_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [45.10,-9.75,71.65,-2.40,81.10,24.15,74.70,54.90,41.95,63.30,12.60,59.45,-6.30,49.65,-11.20,24.85,-7.30,-0.25,17.90,-10.70];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicPopcorn3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 69.00;
	sprite.height = 52.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol47(this: ICharlesDickensCutouts_Symbol47) {
	return this;
}
function CharlesDickensCutouts_dicPopcorn3(this: ICharlesDickensCutouts_dicPopcorn3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicPopcorn4_cutout(this: ICharlesDickensCutouts_dicPopcorn4_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [54.20,-5.60,68.20,-4.90,91.30,8.05,101.05,24.50,101.40,47.20,93.05,59.10,79.40,77.30,49.70,80.10,26.60,72.40,17.85,66.10,-5.55,51.05,-8.70,25.90,2.15,4.55,20.30,-10.50];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicPopcorn4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 91.00;
	sprite.height = 68.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol48(this: ICharlesDickensCutouts_Symbol48) {
	return this;
}
function CharlesDickensCutouts_dicPopcorn4(this: ICharlesDickensCutouts_dicPopcorn4) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-4.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaBubbles1_cutout(this: ICharlesDickensCutouts_dicSeaBubbles1_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaBubbles1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 352.00;
	sprite.height = 454.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicSeaBubbles1(this: ICharlesDickensCutouts_dicSeaBubbles1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-bubbles-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaBubbles2_cutout(this: ICharlesDickensCutouts_dicSeaBubbles2_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaBubbles2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 499.00;
	sprite.height = 427.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicSeaBubbles2(this: ICharlesDickensCutouts_dicSeaBubbles2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-bubbles-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaBubbles3_cutout(this: ICharlesDickensCutouts_dicSeaBubbles3_cutout) {
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaBubbles3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 304.00;
	sprite.height = 427.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_dicSeaBubbles3(this: ICharlesDickensCutouts_dicSeaBubbles3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-bubbles-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaFish1_cutout(this: ICharlesDickensCutouts_dicSeaFish1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [17.05,-5.05,32.55,10.30,55.80,15.90,89.75,1.35,135.15,-11.10,176.20,-5.95,225.70,23.15,225.35,54.75,182.10,74.40,130.05,75.65,69.60,60.65,46.50,63.75,22.25,83.85,-1.65,85.55,-7.65,63.30,0.05,41.95,-12.80,23.10,-8.50,-5.95];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaFish1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 217.00;
	sprite.height = 78.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol49(this: ICharlesDickensCutouts_Symbol49) {
	return this;
}
function CharlesDickensCutouts_dicSeaFish1(this: ICharlesDickensCutouts_dicSeaFish1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-fish-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaFish2_cutout(this: ICharlesDickensCutouts_dicSeaFish2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [53.45,5.75,112.60,9.70,146.75,4.00,169.50,-8.70,193.65,-8.70,197.10,32.90,190.95,63.55,167.35,63.55,152.45,53.05,141.95,53.90,117.40,69.65,82.35,81.95,53.05,80.60,23.70,68.35,0.05,50.85,-7.85,36.40,-6.10,9.70,18.00,2.65];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaFish2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 187.00;
	sprite.height = 68.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol50(this: ICharlesDickensCutouts_Symbol50) {
	return this;
}
function CharlesDickensCutouts_dicSeaFish2(this: ICharlesDickensCutouts_dicSeaFish2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-fish-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaPlant1_cutout(this: ICharlesDickensCutouts_dicSeaPlant1_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [129.05,-9.40,127.65,10.75,112.80,31.75,108.75,60.85,121.55,83.00,143.80,119.80,151.90,96.85,174.80,98.30,179.85,66.35,188.25,52.70,195.95,25.70,196.85,4.30,218.20,0.05,241.30,6.90,240.45,77.05,249.85,82.15,254.15,150.60,267.85,159.15,268.70,185.70,277.25,191.70,277.70,212.50,280.75,228.05,297.50,258.40,301.20,276.30,303.55,311.85,294.35,324.20,263.55,326.80,235.55,341.35,182.00,351.90,124.05,354.15,62.45,348.20,38.90,342.50,28.25,333.40,3.45,329.35,-11.10,314.80,-14.55,291.70,-3.40,263.50,1.75,241.25,15.40,224.10,41.10,219.00,45.40,187.35,53.95,147.15,51.40,83.05,66.80,71.00,71.90,31.65,89.90,6.85,102.30,-6.95];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaPlant1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 293.00;
	sprite.height = 341.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol51(this: ICharlesDickensCutouts_Symbol51) {
	return this;
}
function CharlesDickensCutouts_dicSeaPlant1(this: ICharlesDickensCutouts_dicSeaPlant1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-plant-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaPlant2_cutout(this: ICharlesDickensCutouts_dicSeaPlant2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [131.10,-10.00,139.25,1.95,145.60,26.10,166.20,32.30,177.10,73.65,178.55,94.80,199.25,97.35,206.05,124.30,204.65,149.05,228.70,155.90,240.00,172.10,246.55,208.75,269.90,219.05,287.05,243.70,292.15,267.85,289.10,289.60,274.00,300.55,252.70,304.15,220.75,321.85,173.05,335.05,122.95,335.75,72.80,325.45,43.30,309.65,37.10,291.10,17.20,287.65,9.20,258.00,-5.50,253.35,-8.15,229.35,-0.45,202.45,23.70,167.90,43.30,177.80,35.70,137.35,26.80,116.75,28.25,92.15,39.85,69.35,43.55,49.45,65.25,26.80,93.40,24.05,94.10,6.20,107.50,-12.20];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaPlant2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 279.00;
	sprite.height = 322.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol52(this: ICharlesDickensCutouts_Symbol52) {
	return this;
}
function CharlesDickensCutouts_dicSeaPlant2(this: ICharlesDickensCutouts_dicSeaPlant2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-plant-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSeaPlant3_cutout(this: ICharlesDickensCutouts_dicSeaPlant3_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [169.35,-9.50,177.25,10.75,175.30,34.05,162.85,85.70,165.90,103.70,182.30,108.90,191.90,124.10,195.80,159.05,215.65,137.65,247.30,142.00,239.30,109.75,241.95,80.55,252.15,62.85,263.65,55.30,286.65,55.75,296.40,69.45,302.60,96.00,305.65,119.00,327.35,119.45,335.75,124.75,341.05,142.00,342.40,173.85,337.50,204.35,329.00,238.35,337.50,246.85,340.60,267.65,337.10,291.50,333.55,307.00,343.30,315.40,351.70,337.95,373.35,340.20,384.40,358.75,388.40,389.30,382.20,418.05,371.55,439.25,365.80,448.55,368.45,467.55,366.25,485.25,355.20,497.65,334.40,500.30,310.95,497.65,291.05,500.75,277.85,517.55,252.65,529.50,221.65,535.70,201.75,550.75,181.40,555.15,156.20,552.95,133.20,544.55,114.35,529.25,75.85,531.05,68.15,540.15,52.25,546.75,29.20,546.75,14.20,545.00,8.00,532.60,-3.95,521.55,-8.80,507.85,-6.60,487.05,8.45,468.90,10.80,452.95,-1.80,446.40,-7.10,426.45,3.10,414.50,1.35,394.15,10.65,371.15,30.55,372.00,20.85,339.75,10.65,308.30,8.45,274.70,15.05,249.45,24.35,241.05,32.30,240.60,31.45,216.75,36.75,194.20,64.20,190.20,79.20,205.25,89.85,228.70,96.05,209.20,90.30,177.80,86.75,153.95,95.60,130.50,107.95,129.60,100.90,99.95,100.45,75.60,105.75,58.35,120.35,55.25,122.15,25.25,129.65,4.00,139.95,-10.35];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSeaPlant3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 374.00;
	sprite.height = 541.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol53(this: ICharlesDickensCutouts_Symbol53) {
	return this;
}
function CharlesDickensCutouts_dicSeaPlant3(this: ICharlesDickensCutouts_dicSeaPlant3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-plant-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSmallballoon_cutout(this: ICharlesDickensCutouts_dicSmallballoon_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [82.70,-10.35,115.30,1.45,134.05,20.20,147.80,46.00,150.75,79.25,145.90,95.20,147.95,120.90,144.50,132.70,126.45,134.80,107.00,136.20,82.35,141.60,49.35,138.25,9.05,118.80,-11.80,81.30,-13.15,46.60,6.30,9.75,42.40,-9.65];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSmallballoon.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 138.00;
	sprite.height = 130.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol54(this: ICharlesDickensCutouts_Symbol54) {
	return this;
}
function CharlesDickensCutouts_dicSmallballoon(this: ICharlesDickensCutouts_dicSmallballoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallballoon.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSmallchicken_cutout(this: ICharlesDickensCutouts_dicSmallchicken_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [127.75,-7.10,145.10,16.00,150.00,49.40,154.20,70.20,148.20,96.55,121.50,119.30,117.05,135.75,115.10,149.35,85.50,158.90,63.20,158.45,42.30,153.10,37.85,133.10,39.20,120.20,24.50,112.15,0.05,80.55,-9.75,51.65,-9.30,32.50,-3.55,11.60,20.95,9.35,39.65,24.05,59.65,36.05,85.05,29.85,92.15,9.35,102.35,-8.00];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSmallchicken.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 141.00;
	sprite.height = 147.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol55(this: ICharlesDickensCutouts_Symbol55) {
	return this;
}
function CharlesDickensCutouts_dicSmallchicken(this: ICharlesDickensCutouts_dicSmallchicken) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallchicken.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSmallpopcorn_cutout(this: ICharlesDickensCutouts_dicSmallpopcorn_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [62.35,-8.90,81.85,6.70,84.60,27.85,117.45,27.30,123.00,11.15,136.35,-0.55,162.50,-1.65,192.60,8.35,200.35,27.30,197.60,53.45,190.30,67.60,159.70,73.15,136.90,70.15,124.10,82.95,98.70,88.20,78.50,84.60,60.70,77.95,30.65,81.30,5.60,76.25,-7.75,64.60,-10.00,41.20,2.25,14.50,12.25,-3.30,38.40,-11.10];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSmallpopcorn.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 187.00;
	sprite.height = 76.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol56(this: ICharlesDickensCutouts_Symbol56) {
	return this;
}
function CharlesDickensCutouts_dicSmallpopcorn(this: ICharlesDickensCutouts_dicSmallpopcorn) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallpopcorn.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSmallworms_cutout(this: ICharlesDickensCutouts_dicSmallworms_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [158.15,-3.90,163.10,14.50,186.50,25.60,212.25,36.60,218.20,62.55,203.75,74.00,162.55,80.15,118.00,80.15,75.70,72.35,40.65,80.15,12.25,81.30,-5.00,74.60,-9.45,60.70,-8.35,45.10,6.15,24.50,36.75,12.25,50.10,0.00,66.25,-5.55,94.10,-5.55,117.45,-10.55,142.50,-11.10];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSmallworms.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 208.00;
	sprite.height = 69.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol57(this: ICharlesDickensCutouts_Symbol57) {
	return this;
}
function CharlesDickensCutouts_dicSmallworms(this: ICharlesDickensCutouts_dicSmallworms) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallworms.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSpacePlanet2_cutout(this: ICharlesDickensCutouts_dicSpacePlanet2_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [174.25,-7.65,218.85,15.35,250.90,42.50,274.15,88.45,282.95,137.30,276.70,174.95,255.10,220.20,225.80,249.45,186.10,272.45,132.30,281.75,80.45,271.20,37.65,248.75,2.10,204.20,-10.40,163.05,-11.80,113.55,-2.05,77.30,20.90,36.95,54.35,9.05,89.90,-6.25,131.70,-13.25];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSpacePlanet2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 269.00;
	sprite.height = 268.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol58(this: ICharlesDickensCutouts_Symbol58) {
	return this;
}
function CharlesDickensCutouts_dicSpacePlanet2(this: ICharlesDickensCutouts_dicSpacePlanet2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-planet-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSpacePlanet3_cutout(this: ICharlesDickensCutouts_dicSpacePlanet3_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [726.25,57.95,791.05,83.55,833.70,112.55,980.30,64.80,1132.05,18.75,1259.90,-13.65,1305.95,-8.50,1314.45,17.05,1276.80,50.70,1160.65,118.80,1045.35,178.20,908.25,242.85,916.15,289.10,909.15,369.45,880.30,441.05,826.15,499.55,758.05,542.30,689.05,558.90,623.50,558.05,565.90,542.30,517.85,516.10,478.55,481.20,442.75,442.75,297.85,496.95,141.50,550.20,48.95,576.40,14.00,579.05,-7.80,571.15,-11.30,544.10,13.15,519.65,88.25,469.85,235.75,385.10,406.95,297.85,418.30,226.20,445.35,168.55,490.75,114.45,548.40,76.85,602.75,55.50,658.10,49.45];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSpacePlanet3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1298.00;
	sprite.height = 566.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol59(this: ICharlesDickensCutouts_Symbol59) {
	return this;
}
function CharlesDickensCutouts_dicSpacePlanet3(this: ICharlesDickensCutouts_dicSpacePlanet3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-planet-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSpacePlanet4_cutout(this: ICharlesDickensCutouts_dicSpacePlanet4_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [99.65,-10.50,131.20,11.20,145.95,40.00,150.50,73.50,141.70,106.65,113.65,137.50,78.60,149.40,34.40,145.20,1.45,120.65,-13.30,84.20,-13.85,49.60,3.05,11.90,32.30,-8.40,64.55,-13.30];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSpacePlanet4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 136.00;
	sprite.height = 135.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol60(this: ICharlesDickensCutouts_Symbol60) {
	return this;
}
function CharlesDickensCutouts_dicSpacePlanet4(this: ICharlesDickensCutouts_dicSpacePlanet4) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-planet-4.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSpaceSatellite_cutout(this: ICharlesDickensCutouts_dicSpaceSatellite_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [497.70,10.55,499.10,42.85,475.95,61.10,461.90,70.90,456.95,84.95,462.60,115.85,463.25,150.85,447.15,181.45,423.00,191.60,398.05,192.35,379.45,184.95,348.15,202.55,449.90,285.70,448.60,310.50,397.80,339.45,375.60,339.75,267.50,268.10,265.40,250.55,204.30,284.95,181.85,291.30,158.00,287.80,141.15,280.05,127.80,289.20,100.15,288.55,95.50,264.60,102.50,249.85,100.60,238.85,113.05,232.30,115.85,204.25,125.70,185.30,160.90,157.50,138.30,163.55,121.45,162.10,-8.40,78.65,-9.80,49.85,59.70,-4.90,86.35,-6.30,207.10,89.85,208.50,117.25,271.70,64.60,282.90,59.70,287.15,29.50,301.15,4.90,328.55,-9.10,356.60,-8.40,387.50,4.25,406.45,18.25,428.25,15.45,437.35,4.25,454.20,-7.70,479.45,-4.90];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSpaceSatellite.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 489.00;
	sprite.height = 331.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol61(this: ICharlesDickensCutouts_Symbol61) {
	return this;
}
function CharlesDickensCutouts_dicSpaceSatellite(this: ICharlesDickensCutouts_dicSpaceSatellite) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-satellite.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicSpaceship_cutout(this: ICharlesDickensCutouts_dicSpaceship_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [34.55,-13.25,95.60,-10.60,141.65,3.60,170.85,26.60,235.45,99.15,322.70,203.30,541.55,207.95,911.40,212.40,995.50,215.95,1031.75,227.45,1073.35,246.95,1122.90,279.60,1168.05,300.85,1212.30,326.50,1237.05,359.25,1237.05,390.20,1223.80,418.55,1318.45,420.30,1436.15,426.50,1521.10,439.80,1578.60,459.25,1611.55,475.85,1654.05,506.50,1685.70,546.00,1695.45,584.05,1684.85,621.20,1661.85,647.75,1620.20,677.45,1568.05,704.35,1504.30,724.70,1421.45,735.65,1319.35,740.65,1252.10,741.50,1143.25,745.95,995.45,748.60,867.15,747.75,759.20,745.95,653.00,747.75,405.30,744.15,223.90,740.60,115.95,733.55,102.65,724.70,92.95,684.90,28.35,698.85,6.20,694.40,-4.90,649.60,-6.10,586.65,-4.35,515.90,5.15,483.05,31.00,482.25,86.75,498.15,92.05,464.55,38.05,471.60,12.40,466.30,5.35,433.55,4.45,359.25,19.50,276.10,30.10,236.25,44.25,227.40,88.50,224.75,25.70,106.20,-11.50,25.65,-13.25,2.65,-3.50,-7.05];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicSpaceship.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1680.00;
	sprite.height = 733.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol62(this: ICharlesDickensCutouts_Symbol62) {
	return this;
}
function CharlesDickensCutouts_dicSpaceship(this: ICharlesDickensCutouts_dicSpaceship) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-spaceship.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicTennisracket_cutout(this: ICharlesDickensCutouts_dicTennisracket_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [371.30,37.10,378.55,80.45,371.30,130.15,338.40,174.80,298.60,205.10,245.75,227.70,195.55,240.65,150.00,263.05,136.75,281.15,94.90,315.45,64.20,358.65,37.10,383.05,9.10,383.05,-8.10,367.70,-10.55,335.95,21.75,306.25,105.75,224.85,129.20,173.50,144.55,110.25,166.25,56.05,193.60,21.90,233.10,-3.60,282.80,-14.45,315.30,-9.90,346.05,7.25];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicTennisracket.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 365.00;
	sprite.height = 372.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol63(this: ICharlesDickensCutouts_Symbol63) {
	return this;
}
function CharlesDickensCutouts_dicTennisracket(this: ICharlesDickensCutouts_dicTennisracket) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-tennisracket.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicWhale_cutout(this: ICharlesDickensCutouts_dicWhale_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [913.65,58.30,994.65,86.70,1045.80,82.45,1131.05,66.80,1179.80,63.40,1211.40,77.90,1214.90,103.75,1307.30,112.30,1385.45,110.90,1551.70,75.35,1601.45,76.80,1658.30,28.50,1725.05,-8.50,1783.30,-14.15,1834.50,4.30,1833.75,29.05,1806.65,46.10,1776.95,83.55,1740.05,124.25,1789.00,142.15,1853.45,148.05,1853.35,177.55,1790.55,187.65,1708.00,177.65,1600.85,154.95,1392.55,302.70,1293.05,353.85,1182.25,390.80,1088.45,413.55,1141.60,466.80,1147.35,493.60,1124.45,510.75,1089.55,503.65,954.40,428.50,875.40,435.45,909.40,544.30,921.40,592.90,915.15,625.10,881.50,627.70,799.65,521.25,695.50,431.20,565.15,415.35,483.95,415.70,413.95,399.35,314.75,365.70,199.25,323.85,161.00,312.00,93.70,311.10,64.60,303.85,21.85,262.95,1.85,213.85,-1.80,180.15,10.05,162.90,59.15,137.40,155.55,96.45,222.90,63.70,297.45,43.70,381.15,32.75,489.40,6.40,569.40,-7.25,668.60,-5.60,799.00,20.45];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicWhale.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1845.00;
	sprite.height = 642.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol64(this: ICharlesDickensCutouts_Symbol64) {
	return this;
}
function CharlesDickensCutouts_dicWhale(this: ICharlesDickensCutouts_dicWhale) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-whale.png", 0.000, 0.000);
	return this;
}
function CharlesDickensCutouts_dicWorms_cutout(this: ICharlesDickensCutouts_dicWorms_cutout) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [270.95,-12.95,307.00,-6.65,326.30,22.10,388.35,15.85,427.85,16.65,463.65,8.10,506.70,9.30,523.70,19.75,557.40,20.90,585.25,27.90,629.35,30.20,649.50,0.45,685.40,-14.30,725.75,-5.90,747.80,24.40,768.65,27.90,802.35,40.65,839.00,27.90,892.45,22.45,937.75,35.95,969.65,62.35,970.70,93.95,1012.95,92.90,1015.25,122.35,975.35,134.70,943.70,133.60,935.95,147.90,896.75,147.55,856.15,165.30,875.85,182.25,870.20,195.20,843.80,201.35,807.00,204.80,765.25,214.85,740.45,202.45,705.90,204.05,668.00,200.50,649.85,206.75,627.75,199.00,579.30,200.90,549.95,194.00,508.90,196.25,463.30,191.60,440.60,199.75,406.95,198.90,356.15,187.40,297.20,199.00,279.40,197.05,241.60,199.40,199.40,193.95,191.40,208.25,156.15,205.65,155.60,185.45,103.45,180.80,83.45,186.30,72.40,175.95,54.90,178.85,45.30,161.45,38.65,153.30,39.50,131.25,52.25,120.80,1.20,120.80,-10.45,111.50,-9.25,88.30,5.80,73.20,61.55,69.70,68.50,61.60,138.55,48.60,178.85,53.45,203.60,44.25,229.50,45.95,254.10,41.35,245.00,26.75,245.35,-1.05];
	}
	const sprite = this.sprite;
	CharlesDickensCutouts_dicWorms.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1006.00;
	sprite.height = 212.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function CharlesDickensCutouts_Symbol65(this: ICharlesDickensCutouts_Symbol65) {
	return this;
}
function CharlesDickensCutouts_dicWorms(this: ICharlesDickensCutouts_dicWorms) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-worms.png", 0.000, 0.000);
	return this;
}
interface ICharlesDickensCutoutsArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ICharlesDickensCutoutsContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ICharlesDickensCutoutsSprite extends ICharlesDickensCutoutsContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ICharlesDickensCutoutsText extends ICharlesDickensCutoutsContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ICharlesDickensCutoutsPolygon extends Array<number> {
}
interface ICharlesDickensCutouts {
	readonly cutouts: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_dicAirplane_cutout|ICharlesDickensCutouts_dicBAgast_cutout|ICharlesDickensCutouts_dicBalloons_cutout|ICharlesDickensCutouts_dicBanana_cutout|ICharlesDickensCutouts_dicBaseballField_cutout|ICharlesDickensCutouts_dicBaseballLights_cutout|ICharlesDickensCutouts_dicBBaseball_cutout|ICharlesDickensCutouts_dicBButterfly_cutout|ICharlesDickensCutouts_dicBCircus_cutout|ICharlesDickensCutouts_dicBConcerned_cutout|ICharlesDickensCutouts_dicBeanbag_cutout|ICharlesDickensCutouts_dicBed_cutout|ICharlesDickensCutouts_dicBExcited_cutout|ICharlesDickensCutouts_dicBFlying_cutout|ICharlesDickensCutouts_dicBHome_cutout|ICharlesDickensCutouts_dicBlanket_cutout|ICharlesDickensCutouts_dicBLaying_cutout|ICharlesDickensCutouts_dicBMuseum_cutout|ICharlesDickensCutouts_dicBowlingball_cutout|ICharlesDickensCutouts_dicBPointing_cutout|ICharlesDickensCutouts_dicBScared_cutout|ICharlesDickensCutouts_dicBSea_cutout|ICharlesDickensCutouts_dicBSittingconfused_cutout|ICharlesDickensCutouts_dicBSpace_cutout|ICharlesDickensCutouts_dicButterflyB_cutout|ICharlesDickensCutouts_dicButterflyBack_cutout|ICharlesDickensCutouts_dicButterflyFront_cutout|ICharlesDickensCutouts_dicButterflyR_cutout|ICharlesDickensCutouts_dicButterflyY_cutout|ICharlesDickensCutouts_dicCastle_cutout|ICharlesDickensCutouts_dicChickens1_cutout|ICharlesDickensCutouts_dicChickens2_cutout|ICharlesDickensCutouts_dicChickens3_cutout|ICharlesDickensCutouts_dicChickens4_cutout|ICharlesDickensCutouts_dicChickens5_cutout|ICharlesDickensCutouts_dicChickens6_cutout|ICharlesDickensCutouts_dicChickens7_cutout|ICharlesDickensCutouts_dicChickens8_cutout|ICharlesDickensCutouts_dicChickens9_cutout|ICharlesDickensCutouts_dicCircus_cutout|ICharlesDickensCutouts_dicCloud1_cutout|ICharlesDickensCutouts_dicCloud2_cutout|ICharlesDickensCutouts_dicCloud3_cutout|ICharlesDickensCutouts_dicCloudsFront_cutout|ICharlesDickensCutouts_dicCouch_cutout|ICharlesDickensCutouts_dicLollipop_cutout|ICharlesDickensCutouts_dicMuseum_cutout|ICharlesDickensCutouts_dicPopcorn_cutout|ICharlesDickensCutouts_dicPopcorn1_cutout|ICharlesDickensCutouts_dicPopcorn2_cutout|ICharlesDickensCutouts_dicPopcorn3_cutout|ICharlesDickensCutouts_dicPopcorn4_cutout|ICharlesDickensCutouts_dicSeaBubbles1_cutout|ICharlesDickensCutouts_dicSeaBubbles2_cutout|ICharlesDickensCutouts_dicSeaBubbles3_cutout|ICharlesDickensCutouts_dicSeaFish1_cutout|ICharlesDickensCutouts_dicSeaFish2_cutout|ICharlesDickensCutouts_dicSeaPlant1_cutout|ICharlesDickensCutouts_dicSeaPlant2_cutout|ICharlesDickensCutouts_dicSeaPlant3_cutout|ICharlesDickensCutouts_dicSmallballoon_cutout|ICharlesDickensCutouts_dicSmallchicken_cutout|ICharlesDickensCutouts_dicSmallpopcorn_cutout|ICharlesDickensCutouts_dicSmallworms_cutout|ICharlesDickensCutouts_dicSpacePlanet2_cutout|ICharlesDickensCutouts_dicSpacePlanet3_cutout|ICharlesDickensCutouts_dicSpacePlanet4_cutout|ICharlesDickensCutouts_dicSpaceSatellite_cutout|ICharlesDickensCutouts_dicSpaceship_cutout|ICharlesDickensCutouts_dicTennisracket_cutout|ICharlesDickensCutouts_dicWhale_cutout|ICharlesDickensCutouts_dicWorms_cutout>;
}
interface ICharlesDickensCutouts_dicAirplane_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol1>;
	readonly sprite: ICharlesDickensCutouts_dicAirplane;
}
interface ICharlesDickensCutouts_Symbol1 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicAirplane extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBAgast_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol2>;
	readonly sprite: ICharlesDickensCutouts_dicBAgast;
}
interface ICharlesDickensCutouts_Symbol2 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBAgast extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBalloons_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol3>;
	readonly sprite: ICharlesDickensCutouts_dicBalloons;
}
interface ICharlesDickensCutouts_Symbol3 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBalloons extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBanana_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol4>;
	readonly sprite: ICharlesDickensCutouts_dicBanana;
}
interface ICharlesDickensCutouts_Symbol4 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBanana extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBaseballField_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol5>;
	readonly sprite: ICharlesDickensCutouts_dicBaseballField;
}
interface ICharlesDickensCutouts_Symbol5 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBaseballField extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBaseballLights_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol6>;
	readonly sprite: ICharlesDickensCutouts_dicBaseballLights;
}
interface ICharlesDickensCutouts_Symbol6 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBaseballLights extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBBaseball_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol7>;
	readonly sprite: ICharlesDickensCutouts_dicBBaseball;
}
interface ICharlesDickensCutouts_Symbol7 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBBaseball extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBButterfly_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol8>;
	readonly sprite: ICharlesDickensCutouts_dicBButterfly;
}
interface ICharlesDickensCutouts_Symbol8 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBButterfly extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBCircus_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol9>;
	readonly sprite: ICharlesDickensCutouts_dicBCircus;
}
interface ICharlesDickensCutouts_Symbol9 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBCircus extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBConcerned_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol10>;
	readonly sprite: ICharlesDickensCutouts_dicBConcerned;
}
interface ICharlesDickensCutouts_Symbol10 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBConcerned extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBeanbag_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol11>;
	readonly sprite: ICharlesDickensCutouts_dicBeanbag;
}
interface ICharlesDickensCutouts_Symbol11 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBeanbag extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBed_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol12>;
	readonly sprite: ICharlesDickensCutouts_dicBed;
}
interface ICharlesDickensCutouts_Symbol12 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBed extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBExcited_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol13>;
	readonly sprite: ICharlesDickensCutouts_dicBExcited;
}
interface ICharlesDickensCutouts_Symbol13 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBExcited extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBFlying_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol14>;
	readonly sprite: ICharlesDickensCutouts_dicBFlying;
}
interface ICharlesDickensCutouts_Symbol14 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBFlying extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBHome_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol15>;
	readonly sprite: ICharlesDickensCutouts_dicBHome;
}
interface ICharlesDickensCutouts_Symbol15 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBHome extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBlanket_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol16>;
	readonly sprite: ICharlesDickensCutouts_dicBlanket;
}
interface ICharlesDickensCutouts_Symbol16 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBlanket extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBLaying_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol17>;
	readonly sprite: ICharlesDickensCutouts_dicBLaying;
}
interface ICharlesDickensCutouts_Symbol17 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBLaying extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBMuseum_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol18>;
	readonly sprite: ICharlesDickensCutouts_dicBMuseum;
}
interface ICharlesDickensCutouts_Symbol18 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBMuseum extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBowlingball_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol19>;
	readonly sprite: ICharlesDickensCutouts_dicBowlingball;
}
interface ICharlesDickensCutouts_Symbol19 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBowlingball extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBPointing_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol20>;
	readonly sprite: ICharlesDickensCutouts_dicBPointing;
}
interface ICharlesDickensCutouts_Symbol20 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBPointing extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBScared_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol21>;
	readonly sprite: ICharlesDickensCutouts_dicBScared;
}
interface ICharlesDickensCutouts_Symbol21 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBScared extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBSea_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol22>;
	readonly sprite: ICharlesDickensCutouts_dicBSea;
}
interface ICharlesDickensCutouts_Symbol22 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBSea extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBSittingconfused_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol23>;
	readonly sprite: ICharlesDickensCutouts_dicBSittingconfused;
}
interface ICharlesDickensCutouts_Symbol23 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBSittingconfused extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicBSpace_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol24>;
	readonly sprite: ICharlesDickensCutouts_dicBSpace;
}
interface ICharlesDickensCutouts_Symbol24 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicBSpace extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicButterflyB_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol25>;
	readonly sprite: ICharlesDickensCutouts_dicButterflyB;
}
interface ICharlesDickensCutouts_Symbol25 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicButterflyB extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicButterflyBack_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol26>;
	readonly sprite: ICharlesDickensCutouts_dicButterflyBack;
}
interface ICharlesDickensCutouts_Symbol26 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicButterflyBack extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicButterflyFront_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol27>;
	readonly sprite: ICharlesDickensCutouts_dicButterflyFront;
}
interface ICharlesDickensCutouts_Symbol27 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicButterflyFront extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicButterflyR_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol28>;
	readonly sprite: ICharlesDickensCutouts_dicButterflyR;
}
interface ICharlesDickensCutouts_Symbol28 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicButterflyR extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicButterflyY_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol29>;
	readonly sprite: ICharlesDickensCutouts_dicButterflyY;
}
interface ICharlesDickensCutouts_Symbol29 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicButterflyY extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCastle_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol30>;
	readonly sprite: ICharlesDickensCutouts_dicCastle;
}
interface ICharlesDickensCutouts_Symbol30 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicCastle extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens1_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol31>;
	readonly sprite: ICharlesDickensCutouts_dicChickens1;
}
interface ICharlesDickensCutouts_Symbol31 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens1 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens2_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol32>;
	readonly sprite: ICharlesDickensCutouts_dicChickens2;
}
interface ICharlesDickensCutouts_Symbol32 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens3_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol33>;
	readonly sprite: ICharlesDickensCutouts_dicChickens3;
}
interface ICharlesDickensCutouts_Symbol33 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens3 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens4_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol34>;
	readonly sprite: ICharlesDickensCutouts_dicChickens4;
}
interface ICharlesDickensCutouts_Symbol34 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens4 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens5_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol35>;
	readonly sprite: ICharlesDickensCutouts_dicChickens5;
}
interface ICharlesDickensCutouts_Symbol35 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens5 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens6_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol36>;
	readonly sprite: ICharlesDickensCutouts_dicChickens6;
}
interface ICharlesDickensCutouts_Symbol36 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens6 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens7_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol37>;
	readonly sprite: ICharlesDickensCutouts_dicChickens7;
}
interface ICharlesDickensCutouts_Symbol37 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens7 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens8_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol38>;
	readonly sprite: ICharlesDickensCutouts_dicChickens8;
}
interface ICharlesDickensCutouts_Symbol38 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens8 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicChickens9_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol39>;
	readonly sprite: ICharlesDickensCutouts_dicChickens9;
}
interface ICharlesDickensCutouts_Symbol39 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicChickens9 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCircus_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol40>;
	readonly sprite: ICharlesDickensCutouts_dicCircus;
}
interface ICharlesDickensCutouts_Symbol40 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicCircus extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCloud1_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicCloud1;
}
interface ICharlesDickensCutouts_dicCloud1 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCloud2_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicCloud2;
}
interface ICharlesDickensCutouts_dicCloud2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCloud3_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicCloud3;
}
interface ICharlesDickensCutouts_dicCloud3 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCloudsFront_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicCloudsFront;
}
interface ICharlesDickensCutouts_dicCloudsFront extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicCouch_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol41>;
	readonly sprite: ICharlesDickensCutouts_dicCouch;
}
interface ICharlesDickensCutouts_Symbol41 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicCouch extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicLollipop_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol42>;
	readonly sprite: ICharlesDickensCutouts_dicLollipop;
}
interface ICharlesDickensCutouts_Symbol42 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicLollipop extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicMuseum_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol43>;
	readonly sprite: ICharlesDickensCutouts_dicMuseum;
}
interface ICharlesDickensCutouts_Symbol43 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicMuseum extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicPopcorn_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol44>;
	readonly sprite: ICharlesDickensCutouts_dicPopcorn;
}
interface ICharlesDickensCutouts_Symbol44 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicPopcorn extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicPopcorn1_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol45>;
	readonly sprite: ICharlesDickensCutouts_dicPopcorn1;
}
interface ICharlesDickensCutouts_Symbol45 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicPopcorn1 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicPopcorn2_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol46>;
	readonly sprite: ICharlesDickensCutouts_dicPopcorn2;
}
interface ICharlesDickensCutouts_Symbol46 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicPopcorn2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicPopcorn3_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol47>;
	readonly sprite: ICharlesDickensCutouts_dicPopcorn3;
}
interface ICharlesDickensCutouts_Symbol47 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicPopcorn3 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicPopcorn4_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol48>;
	readonly sprite: ICharlesDickensCutouts_dicPopcorn4;
}
interface ICharlesDickensCutouts_Symbol48 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicPopcorn4 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaBubbles1_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicSeaBubbles1;
}
interface ICharlesDickensCutouts_dicSeaBubbles1 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaBubbles2_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicSeaBubbles2;
}
interface ICharlesDickensCutouts_dicSeaBubbles2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaBubbles3_cutout extends ICharlesDickensCutoutsContainer {
	readonly sprite: ICharlesDickensCutouts_dicSeaBubbles3;
}
interface ICharlesDickensCutouts_dicSeaBubbles3 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaFish1_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol49>;
	readonly sprite: ICharlesDickensCutouts_dicSeaFish1;
}
interface ICharlesDickensCutouts_Symbol49 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSeaFish1 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaFish2_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol50>;
	readonly sprite: ICharlesDickensCutouts_dicSeaFish2;
}
interface ICharlesDickensCutouts_Symbol50 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSeaFish2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaPlant1_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol51>;
	readonly sprite: ICharlesDickensCutouts_dicSeaPlant1;
}
interface ICharlesDickensCutouts_Symbol51 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSeaPlant1 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaPlant2_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol52>;
	readonly sprite: ICharlesDickensCutouts_dicSeaPlant2;
}
interface ICharlesDickensCutouts_Symbol52 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSeaPlant2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSeaPlant3_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol53>;
	readonly sprite: ICharlesDickensCutouts_dicSeaPlant3;
}
interface ICharlesDickensCutouts_Symbol53 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSeaPlant3 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSmallballoon_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol54>;
	readonly sprite: ICharlesDickensCutouts_dicSmallballoon;
}
interface ICharlesDickensCutouts_Symbol54 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSmallballoon extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSmallchicken_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol55>;
	readonly sprite: ICharlesDickensCutouts_dicSmallchicken;
}
interface ICharlesDickensCutouts_Symbol55 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSmallchicken extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSmallpopcorn_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol56>;
	readonly sprite: ICharlesDickensCutouts_dicSmallpopcorn;
}
interface ICharlesDickensCutouts_Symbol56 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSmallpopcorn extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSmallworms_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol57>;
	readonly sprite: ICharlesDickensCutouts_dicSmallworms;
}
interface ICharlesDickensCutouts_Symbol57 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSmallworms extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSpacePlanet2_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol58>;
	readonly sprite: ICharlesDickensCutouts_dicSpacePlanet2;
}
interface ICharlesDickensCutouts_Symbol58 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSpacePlanet2 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSpacePlanet3_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol59>;
	readonly sprite: ICharlesDickensCutouts_dicSpacePlanet3;
}
interface ICharlesDickensCutouts_Symbol59 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSpacePlanet3 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSpacePlanet4_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol60>;
	readonly sprite: ICharlesDickensCutouts_dicSpacePlanet4;
}
interface ICharlesDickensCutouts_Symbol60 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSpacePlanet4 extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSpaceSatellite_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol61>;
	readonly sprite: ICharlesDickensCutouts_dicSpaceSatellite;
}
interface ICharlesDickensCutouts_Symbol61 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSpaceSatellite extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicSpaceship_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol62>;
	readonly sprite: ICharlesDickensCutouts_dicSpaceship;
}
interface ICharlesDickensCutouts_Symbol62 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicSpaceship extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicTennisracket_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol63>;
	readonly sprite: ICharlesDickensCutouts_dicTennisracket;
}
interface ICharlesDickensCutouts_Symbol63 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicTennisracket extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicWhale_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol64>;
	readonly sprite: ICharlesDickensCutouts_dicWhale;
}
interface ICharlesDickensCutouts_Symbol64 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicWhale extends ICharlesDickensCutoutsSprite {
}
interface ICharlesDickensCutouts_dicWorms_cutout extends ICharlesDickensCutoutsContainer {
	readonly polygons: ICharlesDickensCutoutsArray<ICharlesDickensCutouts_Symbol65>;
	readonly sprite: ICharlesDickensCutouts_dicWorms;
}
interface ICharlesDickensCutouts_Symbol65 extends ICharlesDickensCutoutsPolygon {
}
interface ICharlesDickensCutouts_dicWorms extends ICharlesDickensCutoutsSprite {
}
